/* eslint-disable react-hooks/exhaustive-deps */
import CommonLayout from '../layout/CommonLayout';
import { useDispatch, useSelector } from 'react-redux';
import { PRColumns } from '../components/AGColumns/PRsColumn';
import { CommonFunction, formatNumberWithSuffix, formatMetricOneDecimal, truncateToOneDecimal } from '../utils/commonFunctions';
import {
  storeBoardInSession,
  restoreBoardFromSession,
  computeProjectDisplayName,
  getBoardLabels,
  standupPointsModeTabLabel,
} from '../utils/boardUtils';
import { jiraColumnDefs } from '../components/AGColumns/JiraColumn';
import DropdownButton from '../components/Common/DropDown';
import RepoCheckboxDropdown from '../components/Common/RepoCheckboxDropdown';
import DateRangePicker from '../components/Common/CustomDatePicker';
import CommonTooltip, { JiraGraphTooltip } from '../components/Common/ToolTip';
import TooltipIcon from '../utils/TooltipIcon';
import { useState, useRef, useEffect, useMemo, useCallback, lazy, Suspense } from 'react';
import { Search, ThumbsUp, AlertTriangle, ArrowUp, ArrowDown } from 'lucide-react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  CartesianGrid,
  Line,
} from 'recharts';
import {
  setSelectedTypeValue,
  setSprint,
  setRelease,
  setSelectedDeveloperName,
  // setQAReferenceData,
  setStoryChurnData,
  // setBurndownData,
  setBoardListForProject,
  setOrganizationList,
  setHolidayListForCompany,
  setProjectList,
  setSelectedProject as setReduxSelectedProject,
} from '../store/JiraSlices/jiraSlice';
import Spinner from '../components/Common/Spinner';
import { setSelectedRepository } from '../store/GitSlices/gitSlices';
import PropTypes from 'prop-types';
import Modal from '../components/Common/Modal';
import CustomEditableCellRenderer from '../components/AGColumns/CustomEditableCellRenderer';
// For testing purposes we are using unified endpoints. If they work properly, we will remove the commented imports later.
// import {
//   getId,
//   getRoleRatesAndStoryPoints,
//   getBoardList, getBurndownData, getReleaseBurndownData, getPlatformName, PR_FILTER_RANGES,
//   getStoryChurnData,
//   getStoryChurnExcludingBugs,
// } from '../constants';
import {
  getId,
  getBoardList,
  getPlatformName,
  PR_FILTER_RANGES,
  getStandupDashboardData,
  getClickUpIssues,
  getAllOrgsListAPI,
  getHolidayList,
  APP_STRINGS,
  isCreatedDateFilterType,
  isClickupListBoardTypeFromSession,
  getProjectList,
  // getProjectManagementData,
} from '../constants';
// eslint-disable-next-line no-unused-vars
import axiosInstance from '../axiosInstance';
import { useNavigate, useLocation } from 'react-router-dom';
import { pickDefaultProjectForBootstrap } from '../utils/defaultSelectionUtils';
import store from '../store/store';
import SearchFloatingFilter from '../components/Common/searchFloatingFilter';
import {
  processNewBurndownData,
  processReleaseBurndownData,
  generateDateRange,
} from '../utils/burndownUtils';
import '../assets/css/global.scss';
import {
  tailwindColors,
  getWorkingDaysBetweenDates,
  isNearbyMatch,
  createColorMapping,
  getStatusColor,
  isDoneLikeStatus,
  isJiraRowOverdue,
  isJiraRowBlocked,
  resolveIssueScopeFlags,
  rowMatchesScopeIssueKey,
  mergeRemovedRowsIntoResults,
} from '../components/Common/standUpCommonFunctions';
import {
  isBucketAssigneeName,
  isUnassignedBucketName,
  normalizeIssueAssigneeName,
  buildStandupCapacityAssigneesFallback,
  buildIssueEstimateTotalsByAssignee,
  collectStandupDeveloperNames,
  filterAssigneesForCapacityPlanView,
  shouldShowUnassignedCapacityApiAssignee,
  resolveStandupHoursBasedProject,
  resolveStandupScopeData,
  allocatedCapacityForAssignee,
  sumAllocatedFromCapacityPlanAssignees,
  resolveTeamAvailableCapacityFallback,
  resolveAssigneeNetAvailableCapacity,
  sumAssigneeAvailableCapacity,
  enrichStandupCapacityAssigneesFromScope,
  computeCapacityGaugeUtilization,
  computeCapacityBarSegments,
  sortStandupSprintDropdownList,
  formatStandupDisplayDate,
} from '../utils/capacityPlanningUtils';
import QAInsights from '../components/StandUp/QAInsights';
import StandUpPRSummarySection from '../components/StandUp/StandUpPRSummarySection';
import { buildStandupPRSummaryTooltip, isFirstPassApprovedPR } from '../utils/firstPassPrUtils';
import StandUpSprintGoalSuccessSection from '../components/StandUp/StandUpSprintGoalSuccessSection';
import StandUpCapacitySection from '../components/StandUp/StandUpCapacitySection';
import StandUpChurnSection from '../components/StandUp/StandUpChurnSection';
import StandUpToolbarFiltersRow from '../components/StandUp/StandUpToolbarFiltersRow';
import StandUpBurndownSection from '../components/StandUp/StandUpBurndownSection';
import StandUpJiraTableSection from '../components/StandUp/StandUpJiraTableSection';
import { standUpChartSuspenseFallback as chartSuspenseFallback } from '../components/StandUp/StandUpChartSuspenseFallback';
import {
  setMultiProjectCompanyId,
  setMultiProjectFilters,
} from '../store/MultiProjectSlice/multiProjectSlice';
import { scopeMultiProjectFiltersByAccessibleProjects } from '../utils/multiProjectUtils';

const AGrid = lazy(() => import('../components/Common/AGgrid'));
const LazyBurnupChart = lazy(() => import('../components/StandUp/BurnupChart'));
const ReleaseBurndownStackedBar = lazy(() =>
  import('../components/StandUp/ReleaseBurndownStackedBar'),
);
const DailyWiseStatusCountChart = lazy(() =>
  import('../components/StandUp/DailyWiseStatusCountChart'),
);
const ChurnStoryLineChart = lazy(() =>
  import('../components/StandUp/StandUpRechartsCharts').then((m) => ({ default: m.ChurnStoryLineChart })),
);
const ChurnStoryStackedBarChart = lazy(() =>
  import('../components/StandUp/StandUpRechartsCharts').then((m) => ({
    default: m.ChurnStoryStackedBarChart,
  })),
);
const SprintGoalBarChart = lazy(() =>
  import('../components/StandUp/StandUpRechartsCharts').then((m) => ({ default: m.SprintGoalBarChart })),
);
const BurndownSprintLineChart = lazy(() =>
  import('../components/StandUp/StandUpRechartsCharts').then((m) => ({
    default: m.BurndownSprintLineChart,
  })),
);

function assigneeLabelIsUnassigned(name) {
  return String(name ?? '')
    .trim()
    .toLowerCase() === 'unassigned';
}

function getActiveScopeData(selectedValue, currentSprint, currentRelease) {
  if (selectedValue?.value === APP_STRINGS.VALUE_RELEASE) {
    return currentRelease && Object.keys(currentRelease).length > 0 ? currentRelease : null;
  }
  if (selectedValue?.value === APP_STRINGS.VALUE_SPRINT) {
    return currentSprint && Object.keys(currentSprint).length > 0 ? currentSprint : null;
  }
  return null;
}

function getScopeChurnEntries(scopeData, selectedValue) {
  if (!scopeData) return [];
  const isReleaseMode = selectedValue?.value === APP_STRINGS.VALUE_RELEASE;
  const churn = isReleaseMode
    ? scopeData.releaseChurn ?? scopeData.storyChurn
    : scopeData.storyChurn ?? scopeData.releaseChurn;
  return Array.isArray(churn) ? churn : [];
}

function filterStoryChurnEntries(storyChurn, selectedIssueType, excludeBugs) {
  if (!Array.isArray(storyChurn)) return [];
  if (selectedIssueType && selectedIssueType !== 'All') {
    return storyChurn.filter((entry) => entry.issueType === selectedIssueType);
  }
  if (excludeBugs) {
    return storyChurn.filter((entry) => entry.issueType !== 'Bug');
  }
  return storyChurn;
}

function findDeveloperChurnEntry(developerChurn, selectedDeveloper) {
  if (!Array.isArray(developerChurn) || !selectedDeveloper) return null;
  if (assigneeLabelIsUnassigned(selectedDeveloper) || isBucketAssigneeName(selectedDeveloper)) {
    return developerChurn.find((entry) => isBucketAssigneeName(entry.developer));
  }
  return developerChurn.find((entry) => isNearbyMatch(selectedDeveloper, entry.developer));
}

function mergeChurnIssueKeys(churnEntries, keyField, selectedDeveloper) {
  const keys = new Set();
  churnEntries.forEach((entry) => {
    const source = selectedDeveloper
      ? findDeveloperChurnEntry(entry.developerChurn, selectedDeveloper)
      : entry;
    if (!source) return;
    (source[keyField] || []).forEach((key) => {
      if (key) keys.add(String(key).toUpperCase());
    });
  });
  return keys;
}

function passesChurnIssueTypeFilter(row, selectedIssueType, excludeBugs) {
  const type = row?.type;
  if (selectedIssueType && selectedIssueType !== 'All') {
    return type === selectedIssueType;
  }
  if (excludeBugs) return type !== 'Bug';
  return true;
}

function filterRowsByDeveloper(rows, selectedDeveloper, isClickupList) {
  if (!isClickupList || !selectedDeveloper) return rows;
  if (assigneeLabelIsUnassigned(selectedDeveloper) || isBucketAssigneeName(selectedDeveloper)) {
    return rows.filter((row) => {
      const a = row?.assignedTo ?? row?.developer;
      return isBucketAssigneeName(a);
    });
  }
  return rows.filter(
    (row) =>
      isNearbyMatch(selectedDeveloper, row?.assignedTo) ||
      isNearbyMatch(selectedDeveloper, row?.developer),
  );
}

function mapJiraApiIssueToStandupRow(issue) {
  if (!issue) return null;
  const pullRequests = Array.isArray(issue.pullRequests) ? issue.pullRequests : [];
  const prId = pullRequests.length ? pullRequests.map((pr) => pr.prNumber).join(', ') : 'NA';
  return {
    jiraTicket: issue.key,
    type: issue.type !== 'NA' ? issue.type : 'NA',
    prId,
    dueDate:
      issue.duedate !== 'NA' && issue.duedate != null
        ? new Date(issue.duedate).toISOString().split('T')[0]
        : 'No Due Date',
    sprintOutcome: issue.sprintOutcome || { spilledOver: null, sprintNames: [] },
    status: issue.status || 'No Status',
    summary: issue.summary || 'No Summary',
    assignedTo: issue.assignee || 'Unassigned',
    blocker: issue.blockedBy || 'No blocker',
    priority: issue.priority,
    severity: issue.severity ?? 'NA',
    jiraUrl: issue.jiraUrl,
    storyPoints: resolveStandupEstimateDisplay(issue),
    originalEstimate: issue.originalEstimate || 0,
    developer: issue.developer || issue.assignee || 'Unassigned',
    epic: issue.epic || 'No Epic',
    labels: issue.labels || 'No Label',
    timeSpent: issue.timeSpent || 0,
    cycleTime: issue.cycleTime || '0d',
    backflowRate: issue.backflowRate || 0,
    customFields: issue.customFields || {},
    customFieldsByName: issue.customFieldsByName || {},
    scopeFlags: resolveIssueScopeFlags(issue),
  };
}

function normalizeClickUpStatusField(raw) {
  if (raw == null) return 'No Status';
  if (typeof raw === 'string') return raw.trim() || 'No Status';
  if (typeof raw === 'object' && raw !== null && raw.name != null) {
    return String(raw.name).trim() || 'No Status';
  }
  return 'No Status';
}

function normalizeClickUpItemTypeField(issue) {
  const raw =
    issue?.itemType ??
    issue?.type ??
    issue?.taskType ??
    issue?.customItemType;
  if (raw == null || raw === '') return 'NA';
  return typeof raw === 'string' ? raw : String(raw);
}

/** ClickUp milestone list rows carry Mongo `_id` and ClickUp `clickUpTaskId`; issues link via `linkedMilestoneClickUpTaskId`. */
function resolveClickupMilestoneTaskId(sprintList, selectedSprintId) {
  if (!selectedSprintId || !Array.isArray(sprintList)) return null;
  const rec = sprintList.find((s) => s?._id === selectedSprintId);
  if (!rec) return null;
  const id =
    rec.clickUpTaskId ??
    rec.clickupTaskId ??
    rec.taskId ??
    rec.clickUpTaskID;
  return id != null && id !== '' ? String(id) : null;
}

function filterClickupIssuesForSelectedMilestone(issues, milestoneTaskId) {
  if (!milestoneTaskId || !Array.isArray(issues)) return issues || [];
  const mid = String(milestoneTaskId);
  return issues.filter((issue) => {
    if (!issue || typeof issue !== 'object') return false;
    const selfId =
      issue.clickUpTaskId != null
        ? String(issue.clickUpTaskId)
        : String(issue.key || '')
            .replace(/^CU-/i, '')
            .trim();
    if (selfId && selfId === mid) return false;
    const linked =
      issue.linkedMilestoneClickUpTaskId ??
      issue.linkedMilestoneId ??
      issue.linkedMilestone?.clickUpTaskId;
    return linked != null && String(linked) === mid;
  });
}

function jiraIssuesHaveMissingAssignee(issues) {
  if (!Array.isArray(issues)) return false;
  return issues.some((issue) => isUnassignedBucketName(normalizeIssueAssigneeName(issue)));
}

/** Standup STORY POINTS column — value is resolved by the standup jiraData API. */
function resolveStandupEstimateDisplay(issue) {
  const sp = issue?.storyPoints;
  if (sp === null || sp === undefined || sp === '' || sp === 'NA') {
    return 'NA';
  }
  const n = Number(sp);
  return Number.isFinite(n) ? n : 'NA';
}

function getMaxLabelLengthEstimated(data, key) {
  if (!Array.isArray(data) || data.length === 0) return 50;

  const longest = data.reduce((a, b) => ((a[key]?.length || 0) > (b[key]?.length || 0) ? a : b))[
    key
  ];

  const textLength = longest?.length || 0;

  const maxDisplayLength = Math.min(textLength, 18);
  const charWidth = 6.5;
  const estimatedWidth = maxDisplayLength * charWidth;
  const padding = 5;
  const calculatedMargin = Math.ceil(estimatedWidth + padding);

  const minMargin = 20;
  const maxMargin = 50;

  return Math.max(minMargin, Math.min(calculatedMargin, maxMargin));
}

/** Maps ClickUp `/getClickUpIssues` items into the grid row shape when standup `issues` is empty. */
function mapClickUpApiIssueToStandupRow(issue) {
  if (!issue || typeof issue !== 'object') return null;
  const key =
    issue.key ||
    issue.customId ||
    issue.taskId ||
    issue.id ||
    issue.task_id ||
    issue.clickupId ||
    'NA';
  const pullRequests = Array.isArray(issue.pullRequests) ? issue.pullRequests : [];
  const prId = pullRequests.length
    ? pullRequests.map((pr) => pr.prNumber ?? pr.id).join(', ')
    : 'NA';
  const rawDue =
    issue.duedate ??
    issue.dueDate ??
    issue.due_date ??
    issue.dueDateMs ??
    (issue.dueDate === null || issue.dueDate === undefined ? null : issue.dueDate);
  let dueDate = 'No Due Date';
  if (rawDue != null && rawDue !== 'NA' && rawDue !== '') {
    const d = new Date(typeof rawDue === 'number' ? rawDue : rawDue);
    if (!Number.isNaN(d.getTime())) {
      dueDate = d.toISOString().split('T')[0];
    }
  }
  const originalEstimateHrs = Number(issue.originalEstimateHrs) || 0;
  const timeSpentHrs = Number(issue.timeSpentHrs) || 0;
  const typeRaw = normalizeClickUpItemTypeField(issue);
  const type = typeRaw && typeRaw !== 'NA' ? typeRaw : 'NA';
  const status = normalizeClickUpStatusField(issue.status);
  return {
    jiraTicket: String(key),
    type,
    prId,
    dueDate,
    sprintOutcome: issue.sprintOutcome || { spilledOver: null, sprintNames: [] },
    status,
    summary: issue.summary || issue.name || issue.taskName || 'No Summary',
    assignedTo: issue.assignee != null ? String(issue.assignee) : 'Unassigned',
    blocker: issue.blockedBy || 'No blocker',
    priority: issue.priority,
    severity: issue.severity ?? 'NA',
    jiraUrl: issue.jiraUrl || issue.url || issue.taskUrl || '',
    storyPoints: issue.storyPoints || 0,
    originalEstimate: issue.originalEstimate ?? originalEstimateHrs,
    developer: issue.developer || issue.assignee || 'Unassigned',
    epic: issue.epic || 'No Epic',
    labels: issue.labels || 'No Label',
    timeSpent: issue.timeSpent ?? timeSpentHrs,
    cycleTime: issue.cycleTime || '0d',
    backflowRate: issue.backflowRate || 0,
    customFields: issue.customFields || {},
    customFieldsByName: issue.customFieldsByName || {},
    scopeFlags: resolveIssueScopeFlags(issue),
  };
}

const STANDUP_RANDOMIZE_STORAGE_KEY = 'standupDeveloperRandomize';

function getStandupRandomizeStorageKeys() {
  const keys = [STANDUP_RANDOMIZE_STORAGE_KEY];
  try {
    const storedUserData = sessionStorage.getItem('userData');
    const email = storedUserData ? JSON.parse(storedUserData)?.email : null;
    if (email) keys.unshift(`${STANDUP_RANDOMIZE_STORAGE_KEY}:${email}`);
  } catch {
    // ignore malformed userData
  }
  return keys;
}

function readStandupRandomizePreference() {
  try {
    let email = null;
    try {
      const storedUserData = sessionStorage.getItem('userData');
      email = storedUserData ? JSON.parse(storedUserData)?.email : null;
    } catch {
      email = null;
    }
    const keys = email
      ? [`${STANDUP_RANDOMIZE_STORAGE_KEY}:${email}`]
      : [STANDUP_RANDOMIZE_STORAGE_KEY];
    for (const key of keys) {
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') continue;
      return {
        enabled: Boolean(parsed.enabled),
        order: Array.isArray(parsed.order) ? parsed.order : null,
      };
    }
  } catch {
    // ignore malformed storage
  }
  return { enabled: false, order: null };
}

function persistStandupRandomizePreference(enabled, order) {
  const payload = JSON.stringify({
    enabled: Boolean(enabled),
    order: enabled && Array.isArray(order) ? order : null,
  });
  try {
    getStandupRandomizeStorageKeys().forEach((key) => {
      localStorage.setItem(key, payload);
    });
  } catch (error) {
    console.warn('Could not persist standup randomize preference:', error);
  }
}

const StandUpPage = () => {
  const [getAllProjectList, setGetAllProjectList] = useState([]);
  const [getAllOrgsList, setGetAllOrgsList] = useState([]);
  const [getAllSprintList, setGetAllSprintList] = useState([]);
  const [getAllReleaseList, setGetAllReleaseList] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState({ id: '', name: '' });
  const [isOrganizationOpen, setIsOrganizationOpen] = useState(false);
  const { handleProject, handleSprint, handleRelease, handleValue, handleDeveloper, handleTeam, handleBacklogForStandup, handleDateRangeForStandup, clearStandupPrDateRange, handleOrganization } =
    CommonFunction();
  const handleProjectRef = useRef(handleProject);
  handleProjectRef.current = handleProject;

  const [isProjectOpen, setIsProjectOpen] = useState(false);
  const [isValueOpen, setIsValueOpen] = useState(false);
  const [isSprintOpen, setIsSprintOpen] = useState(false);
  const [selectedSprint, setSelectedSprint] = useState({ id: '', name: '' });
  const [loading, setLoading] = useState(false);
  const [selectedRelease, setSelectedRelease] = useState({ id: '', releaseName: '' });
  const [selectedValue, setSelectedValue] = useState({
    label: APP_STRINGS.SELECT_AN_OPTION,
    value: '',
  });
  const [selectedProject, setSelectedProject] = useState({ id: '', name: '' });
  const [selectedBoard, setSelectedBoard] = useState({
    id: '',
    name: '',
    type: '',
  });

  // Compute display name for selected project (includes board name if board is selected)
  const selectedProjectDisplayName = computeProjectDisplayName(selectedProject, selectedBoard);
  const [selectedRepos, setSelectedRepos] = useState([]);
  const [isRepoOpen, setIsRepoOpen] = useState(false);
  const [repoList, setRepoList] = useState([]);
  const [jiraDeveloperStatusData, setJiraDeveloperStatusData] = useState([]);
  const [clickupIssuesForTable, setClickupIssuesForTable] = useState(null);
  const [, setValue1] = useState([null, null]);
  const [currentSprint, setCurrentSprint] = useState({});
  const [currentRelease, setCurrentRelease] = useState({});
  const [selectedDeveloper, setSelectedDeveloper] = useState(null);
  const [assignees, setAssignees] = useState([]);
  const [assigneeStoryPointList, setAssigneeStoryPointList] = useState([]);
  const [assigneeIsOpen, setAssigneeIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedReleaseDate, setSelectedReleaseDate] = useState({
    id: '',
    startDate: '',
    releaseDate: '',
    overdue: false,
  });
  const [releaseDaysInfo, setReleaseDaysInfo] = useState({ remainingDays: 0 });
  const [selectedSprintEndDate, setSelectedSprintEndDate] = useState({ id: '', endDate: '' });
  const [actualSprintEndDate, setActualSprintEndDate] = useState({ id: '', completeDate: '' });
  const [sprintDaysInfo, setSprintDaysInfo] = useState({ days: 0, status: '' });
  const [isStoryPoints, setIsStoryPoints] = useState(true);
  const actualStory = useSelector((state) => state.cxo?.actualStoryPoints) || {
    actualStoryPoints: [],
    mode: APP_STRINGS.API_SPRINT,
  };
  const dailyBurnup = useSelector((state) => state.cxo?.dailyBurnup) || [];
  const [lastLoggedDate, setLastLoggedDate] = useState(null);
  const [overloadCount, setOverloadCount] = useState(0);
  const [underloadCount, setUnderloadCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState('All');
  const [selectedIssueTypes, setSelectedIssueTypes] = useState({});
  const [showAddedWork, setShowAddedWork] = useState(false);
  const [randomizeEnabled, setRandomizeEnabled] = useState(() => {
    return readStandupRandomizePreference().enabled;
  });
  const [randomizedOrder, setRandomizedOrder] = useState(() => {
    return readStandupRandomizePreference().order;
  });
  const [selectedSprintStartDate, setSelectedSprintStartDate] = useState({ id: '', startDate: '' });
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sortOrder, setSortOrder] = useState('default');
  const [isHoursBasedProject, setIsHoursBasedProject] = useState(false);
  const [clearFiltersSignal, setClearFiltersSignal] = useState(0);
  const [getStoryPoints, setStoryPoints] = useState(8);
  const [prFilterType, setPrFilterType] = useState('all');
  const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
  const [remainingCapacity, setRemainingCapacity] = useState([]);
  const [statusCarouselIndex, setStatusCarouselIndex] = useState(0);
  const [statusItemsPerPage, setStatusItemsPerPage] = useState(5);
  const [visibleBadgeCount, setVisibleBadgeCount] = useState(0);
  const statusBadgesRef = useRef(null);
  const statusCarouselContainerRef = useRef(null);
  const [availableCapacity, setAvailableCapacity] = useState([]);
  const [allocatedCapacity, setAllocatedCapacity] = useState([]);
  const [isRemainingNegative, setIsRemainingNegative] = useState(false);
  const [showChurnDetails, setShowChurnDetails] = useState(false);
  const [getCapacity, setCapacity] = useState(0);
  const [excludeBugsInChurn, setExcludeBugsInChurn] = useState(() => {
    const stored = sessionStorage.getItem('excludeBugsInChurn');
    return stored === 'true';
  });
  const [repoSource, setRepoSource] = useState('');
  const jiraData = useSelector((state) => state.jira || {});
  const organizationList = useSelector((state) => state.jira?.organizationList);
  const gitData = useSelector((state) => state.git || {});
  const refreshToken = useSelector((state) => state.jira?.refreshToken);
  const multiProjectFilters = useSelector((state) => state.multiProject?.filters);
  const multiProjectCompanyId = useSelector((state) => state.multiProject?.companyId);
 const {
  sprintLabel,
  releaseLabel,
  isAzure,
  isGitLab,
  isClickupList,
  isGithubIssues,
} = useMemo(
  () =>
    getBoardLabels({
      boardType: selectedBoard?.type,
      selectedBoard,
      projectList:
        getAllProjectList?.length > 0 ? getAllProjectList : jiraData?.projectList,
      selectedProjectId: jiraData?.selectedProjectId,
    }),
  [
    getAllProjectList,
    jiraData?.projectList,
    jiraData?.selectedProjectId,
    selectedBoard,
  ],
);
const standUpSprintDropdownList = useMemo(
  () => sortStandupSprintDropdownList(Array.isArray(getAllSprintList) ? getAllSprintList : []),
  [getAllSprintList],
);
const selectedValueDisplay =
  selectedValue?.value === APP_STRINGS.VALUE_SPRINT
    ? sprintLabel
    : selectedValue?.value === APP_STRINGS.VALUE_RELEASE
      ? releaseLabel
      : selectedValue?.value === APP_STRINGS.VALUE_BACKLOG
        ? APP_STRINGS.VALUE_BACKLOG
        : selectedValue?.value;
const isBacklogMode = selectedValue?.value === APP_STRINGS.VALUE_BACKLOG;
const showBacklogOption =
  !isAzure && !isGitLab && !isClickupList && !isGithubIssues;
const isCreatedDateFilter = isCreatedDateFilterType(selectedValue?.value);
const pointsSourceType = useMemo(() => {
  const fromApi =
    selectedValue?.value === APP_STRINGS.VALUE_SPRINT
      ? jiraData?.Sprint?.pointsSourceType
      : selectedValue?.value === APP_STRINGS.VALUE_RELEASE
        ? jiraData?.Release?.pointsSourceType
        : null;
  return fromApi ?? 'storyPoints';
}, [selectedValue, jiraData]);
  const [burnupModePoints, setBurnupModePoints] = useState(true);
  const todaysVelocity = jiraData?.burndownVelocity?.today ?? 0;
  const yesterdayVelocity = jiraData?.burndownVelocity?.yesterday ?? 0;
  const burndownStatus = todaysVelocity > yesterdayVelocity ? 'greatGoing' : 'moveFaster';
  const columnSelectorRef = useRef(null);
  const dispatch = useDispatch();
  const organizationRef = useRef(null);
  const projectRef = useRef(null);
  const valueRef = useRef(null);
  const sprintRef = useRef(null);
  const repoRef = useRef(null);
  const gridApiRef = useRef(null);
  const prGridApiRef = useRef(null);
  const aGridRef = useRef(null);
  const [isUsingStoryPoints, setIsUsingStoryPoints] = useState(false);
  const [isSprintGoalStoryPoints, setIsSprintGoalStoryPoints] = useState(true);
  const [sprintGoalWorkMode, setSprintGoalWorkMode] = useState('with_added_work');
  const lockToHours =
    (isHoursBasedProject && pointsSourceType !== 'effort') || isClickupList;
  const lockToPoints = !lockToHours;
  const theme = useSelector((state) => state.theme.theme);
  const [heavyChartsReady, setHeavyChartsReady] = useState(false);
  useEffect(() => {
    let idleCallbackId;
    let timeoutId;
    if (typeof window.requestIdleCallback === 'function') {
      idleCallbackId = window.requestIdleCallback(() => setHeavyChartsReady(true), {
        timeout: 2000,
      });
    } else {
      timeoutId = window.setTimeout(() => setHeavyChartsReady(true), 2000);
    }
    return () => {
      if (idleCallbackId !== undefined && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleCallbackId);
      }
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const capacityBarSegments = useMemo(
    () => computeCapacityBarSegments(availableCapacity, allocatedCapacity),
    [availableCapacity, allocatedCapacity],
  );

  const capacityGaugeUtilization = useMemo(
    () => computeCapacityGaugeUtilization(availableCapacity, allocatedCapacity),
    [availableCapacity, allocatedCapacity],
  );

  const capacityGaugeGeom = useMemo(() => {
    const r = 40;
    const sw = 9;
    const circumference = 2 * Math.PI * r;
    const util = Math.max(0, Number(capacityGaugeUtilization) || 0);
    const greenLen = (Math.min(util, 100) / 100) * circumference;
    const redLen = util > 100 ? ((Math.min(util, 200) - 100) / 100) * circumference : 0;
    const isOverloaded = util > 100;
    let gradientRing = null;
    if (isOverloaded) {
      const totalDeg = (Math.min(util, 200) / 100) * 360;
      const transStartDeg = totalDeg * 0.72;
      const spanDeg = totalDeg - transStartDeg;
      const midOffset = spanDeg * 0.53;
      const pxScale = 88 / 104;
      const ringR = r * pxScale;
      const halfStroke = (sw / 2) * pxScale;
      const capDia = halfStroke * 2;
      const endRad = ((totalDeg % 360) * Math.PI) / 180;
      const maskInner = ((ringR - halfStroke) / 44) * 100;
      const maskOuter = ((ringR + halfStroke) / 44) * 100;
      gradientRing = {
        totalDeg,
        transStartDeg,
        midOffset,
        spanDeg,
        capDia,
        halfStroke,
        endCapX: 44 + ringR * Math.sin(endRad),
        endCapY: 44 - ringR * Math.cos(endRad),
        maskInner: maskInner.toFixed(1),
        maskInnerSoft: (maskInner + 1).toFixed(1),
        maskOuterSoft: (maskOuter - 1).toFixed(1),
        maskOuter: maskOuter.toFixed(1),
      };
    }
    return { r, circumference, greenLen, redLen, isOverloaded, gradientRing };
  }, [capacityGaugeUtilization]);

  let chartLineData = jiraData?.storyChurnData?.storyChurn?.overAllData;
  let churnTableData = jiraData?.storyChurnData?.storyChurn?.tableData;
  churnTableData = churnTableData?.map((sprint) => {
    const total = {
      issueType: 'All',
      planned: 0,
      added: 0,
      removed: 0,
      churnRate: 0,
    };
    sprint.churnData.forEach((item) => {
      total.planned += item.planned;
      total.added += item.added;
      total.removed += item.removed;
    });
    total.churnRate = total.planned
      ? parseFloat((((total.added + total.removed) / total.planned) * 100).toFixed(1))
      : 0;
    return {
      ...sprint,
      churnData: [...sprint.churnData, total],
    };
  });

  const buildInitialIssueTypesMap = useCallback(
    (tableData) => {
      const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
      return (tableData || []).reduce((acc, row) => {
        const label = row[labelKey] || row.sprint || row.release;
        acc[label] = 'All';
        return acc;
      }, {});
    },
    [selectedValue?.value],
  );

  // For testing purposes we are using this change. If this endpoint works properly, we will remove the commented code later.
  // const refetchChurn = useCallback(
  //   async (excludeBugs) => {
  //     try {
  //       const typeValue = sessionStorage.getItem('typeValue');
  //       const value = typeValue === 'Release' ? 'release' : 'sprint';
  //       const projectId = getId().projectId;
  //       const api = excludeBugs ? getStoryChurnExcludingBugs : getStoryChurnData;
  //       const response = await api({ projectId, value });
  //       dispatch(setStoryChurnData(response?.data));
  //       setSelectedIssueTypes(buildInitialIssueTypesMap(response?.data?.storyChurn?.tableData));
  //     } catch (error) {
  //       console.error('Error fetching churn data:', error);
  //     }
  //   },
  //   [buildInitialIssueTypesMap, dispatch],
  // );
  const refetchChurn = useCallback(
    async (excludeBugs) => {
      try {
        const typeValue = sessionStorage.getItem('typeValue');
        const value =
          typeValue === APP_STRINGS.VALUE_RELEASE
            ? APP_STRINGS.API_RELEASE
            : APP_STRINGS.API_SPRINT;
        const section = excludeBugs ? 'storyChurnExcludingBugs' : 'storyChurn';
        const response = await getStandupDashboardData({ value, sections: section });
        const churnData = response?.data?.[section];
        if (churnData !== undefined) {
          dispatch(setStoryChurnData(churnData));
          setSelectedIssueTypes(buildInitialIssueTypesMap(churnData?.storyChurn?.tableData));
        }
      } catch (error) {
        console.error('Error fetching churn data:', error);
      }
    },
    [buildInitialIssueTypesMap, dispatch],
  );

  const handleExcludeBugsInChurnToggle = useCallback(
    async (e) => {
      const includeBugsChecked = e.target.checked;
      const nextExclude = !includeBugsChecked;
      setExcludeBugsInChurn(nextExclude);
      sessionStorage.setItem('excludeBugsInChurn', String(nextExclude));
      setSelectedOption('All');
      setSelectedIssueTypes(buildInitialIssueTypesMap(churnTableData));

      await refetchChurn(nextExclude);
    },
    [buildInitialIssueTypesMap, churnTableData, refetchChurn],
  );

  const issueTypes = chartLineData?.length
    ? Object.keys(chartLineData[chartLineData.length - 1]).filter((key) => key !== 'label')
    : [];

  issueTypes.unshift('All');
  const createShortName = (fullName) => {
    if (fullName === 'All') return 'All';
    const words = fullName.split(/[\s_-]+/);
    if (words.length === 1) {
      return fullName.length > 6 ? fullName.substring(0, 4) + '..' : fullName;
    } else if (words.length === 2) {
      const firstWord = words[0];
      const secondWordFirstLetter = words[1].charAt(0).toUpperCase();
      return firstWord + '.' + secondWordFirstLetter;
    } else {
      return words.map((word) => word.charAt(0).toUpperCase()).join('.');
    }
  };

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;

    const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;

    const initialTypes = (churnTableData || []).reduce((acc, row) => {
      const label = row[labelKey] || row.sprint || row.release;
      acc[label] = 'All';
      return acc;
    }, {});

    setSelectedIssueTypes(initialTypes);
    initializedRef.current = true;
  }, [churnTableData, selectedValue]);

  // Burndown + burnup SP/Hrs toggles: ClickUp and standup lock-to-hours force hours; otherwise
  // default from whether the project is hours-based (e.g. Azure effort still allows SP when unlocked).
  useEffect(() => {
    if (isClickupList || lockToHours) {
      setIsStoryPoints(false);
      setBurnupModePoints(false);
      return;
    }
    const preferStoryPoints = !isHoursBasedProject;
    setIsStoryPoints(preferStoryPoints);
    setBurnupModePoints(preferStoryPoints);
  }, [isClickupList, lockToHours, isHoursBasedProject]);

  const handleIssueTypeChange = ({ data, newValue }) => {
    const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
    const label = data[labelKey];

    setSelectedIssueTypes((prev) => ({
      ...prev,
      [label]: newValue,
    }));
  };
  const transformedRowData = useMemo(() => {
    if (!Array.isArray(churnTableData)) return [];

    const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
    return churnTableData.map((row) => {
      const label = row[labelKey] || row.sprint || row.release;
      const selected = selectedIssueTypes[label];
      const data = row.churnData.find((item) => item.issueType === selected) || {};
      return {
        [labelKey]: label,
        issueType: selected,
        planned: data.planned ?? 0,
        added: data.added ?? 0,
        removed: data.removed ?? 0,
        churnRate: data.churnRate ?? 0,
        issueTypeOptions: row.churnData.map((i) => i.issueType),
      };
    });
  }, [churnTableData, selectedIssueTypes, selectedValue]);

  const StoryChurnColumns = [
    {
      headerName:
        selectedValue?.value === APP_STRINGS.VALUE_RELEASE
          ? String(releaseLabel).toUpperCase()
          : String(sprintLabel).toUpperCase(),
      field:
        selectedValue?.value === APP_STRINGS.VALUE_RELEASE
          ? APP_STRINGS.API_RELEASE
          : APP_STRINGS.API_SPRINT,
      filter: false,
    },
    {
      headerName: 'ISSUE TYPE',
      field: 'issueType',
      cellRenderer: CustomEditableCellRenderer,
      cellRendererParams: { issueTypes },
      filter: false,
      maxWidth: 125,
    },
    { headerName: 'PLANNED', field: 'planned', filter: false, maxWidth: 130 },
    { headerName: 'ADDED', field: 'added', filter: false, maxWidth: 130 },
    { headerName: 'REMOVED', field: 'removed', filter: false, maxWidth: 130 },
    {
      headerName: 'CHURN (%)',
      field: 'churnRate',
      valueFormatter: (params) => {
        const planned = Number(params.data?.planned);
        if (planned === 0) {
          return 'N/A';
        }
        const added = Number(params.data?.added ?? 0);
        const removed = Number(params.data?.removed ?? 0);
        if (added === 0 && removed === 0) {
          return 'N/A';
        }
        const value = Number(params.value);
        return isNaN(value) ? 'N/A' : value.toFixed(1);
      },
      filter: false,
      maxWidth: 120,
    },
  ];
  const IssueTypeDropdown = ({ data }) => {
    return (
      <select
        value={data.issueType}
        onChange={(e) => {
          const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
          const label = data[labelKey];
          setSelectedIssueTypes((prev) => ({
            ...prev,
            [label]: e.target.value,
          }));
        }}
        className={`${
          theme === 'light'
            ? 'bg-[#F0F4F8] text-[#24527A] border border-[#D1E2F0]'
            : 'bg-[#0e2439] text-white'
        } rounded px-2 py-[2px]`}
      >
        {data.issueTypeOptions.map((type) => (
          <option
            key={type}
            value={type}
            className={theme === 'light' ? 'text-[#24527A]' : 'text-white'}
          >
            {type}
          </option>
        ))}
      </select>
    );
  };

  IssueTypeDropdown.propTypes = {
    data: PropTypes.shape({
      sprint: PropTypes.string.isRequired,
      issueType: PropTypes.string.isRequired,
      issueTypeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
  };

  const sprintMetrics = jiraData?.Sprint?.committedVsCompletedMetrics || {};
  const isFutureSprintSelected = String(jiraData?.Sprint?.state || '').toLowerCase() === 'future';
  const futureScopeStoryPoints = Math.max(
    Number(sprintMetrics.committedStoryPoints) || 0,
    Number(sprintMetrics.plannedStoryPoints) || 0,
    Number(sprintMetrics.initialStoryPoints) || 0,
  );
  const futureScopeHours = Math.max(
    Number(sprintMetrics.committedHours) || 0,
    Number(sprintMetrics.plannedOriginalEstimateHrs) || 0,
    Number(sprintMetrics.initialHours) || 0,
  );
  const initialStoryPoint = isFutureSprintSelected
    ? futureScopeStoryPoints
    : (sprintMetrics.initialStoryPoints || 0);
  const initialHours = isFutureSprintSelected
    ? futureScopeHours
    : (sprintMetrics.initialOriginalEstimateHrs || 0);
  const spilloverStoryPoints = sprintMetrics.spilloverStoryPoints ?? 0;
  const spilloverHours = sprintMetrics.spilloverHours ?? 0;
  const committedStoryPoints = isFutureSprintSelected
    ? futureScopeStoryPoints
    : (sprintMetrics.committedStoryPoints ?? 0);
  const committedHours = isFutureSprintSelected
    ? futureScopeHours
    : (sprintMetrics.committedHours ?? 0);
  const companyId = getId().companyId;
  const navigate = useNavigate();
  const location = useLocation();
  const newBurndownData = jiraData?.burndownData;
  const dailyWiseStatusCount = jiraData?.dailyWiseStatusCount;

  // Scroll to jira table when navigating with #jira-table hash (e.g. from Release Dashboard Open Issues link)
  useEffect(() => {
    if (location.hash === '#jira-table') {
      const timer = setTimeout(() => {
        document.getElementById('jira-table')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  // Filter from Release Dashboard (Open Issues / Critical / View Blockers): filter Jira table by issue keys or type
  const [navigationJiraFilter, setNavigationJiraFilter] = useState(null);
  useEffect(() => {
    const filter = location.state?.jiraTableFilter;
    if (filter && (filter.issueKeys?.length || filter.filterType)) {
      setNavigationJiraFilter(filter);
    }
  }, [location.state]);

  const isReleaseSelected = selectedValue?.value === APP_STRINGS.VALUE_RELEASE;
  const selectedBoardType = String(selectedBoard?.type || selectedBoard?.boardType || '').toLowerCase();
  const isKanbanRelease =
    (selectedBoardType === 'kanban' || selectedBoardType === 'simple') && isReleaseSelected;

  useEffect(() => {
    const hasSelection = selectedValue?.value === APP_STRINGS.VALUE_RELEASE
      ? !!selectedRelease?.id
      : !!selectedSprint?.id;
    if (!hasSelection) {
      setCapacity(0);
      return;
    }    
    const currentData = resolveStandupScopeData({
      selectedValue,
      selectedSprint,
      selectedRelease,
      sprintList: getAllSprintList,
      releaseList: getAllReleaseList,
      jiraData,
    });
    const issuesForCap = jiraData?.jiraTableData?.issues;
    const isHoursBasedForCap = resolveStandupHoursBasedProject(currentData, {
      sprintList: getAllSprintList,
    });
    let assigneesListForCap = Array.isArray(currentData?.assignees) ? currentData.assignees : [];
    if (assigneesListForCap.length === 0) {
      assigneesListForCap = buildStandupCapacityAssigneesFallback({
        issues: issuesForCap || [],
        userList: jiraData?.userList || [],
        existingAssignees: assigneesListForCap,
        isHoursBased: isHoursBasedForCap,
      });
    }
    assigneesListForCap = enrichStandupCapacityAssigneesFromScope(
      assigneesListForCap,
      currentData,
      jiraData,
    );
    let capacityPlanAssignees = filterAssigneesForCapacityPlanView(
      assigneesListForCap,
      isHoursBasedForCap,
    );
    if (capacityPlanAssignees.length === 0 && Array.isArray(issuesForCap) && issuesForCap.length > 0) {
      capacityPlanAssignees = filterAssigneesForCapacityPlanView(
        enrichStandupCapacityAssigneesFromScope(
          buildStandupCapacityAssigneesFallback({
            issues: issuesForCap,
            userList: jiraData?.userList || [],
            existingAssignees: assigneesListForCap,
            isHoursBased: isHoursBasedForCap,
          }),
          currentData,
          jiraData,
        ),
        isHoursBasedForCap,
      );
    }
    const totalCapacity = sumAssigneeAvailableCapacity(
      capacityPlanAssignees,
      isHoursBasedForCap,
    );
    setCapacity(totalCapacity);
  }, [jiraData, selectedValue, selectedSprint, selectedRelease, getAllSprintList, getAllReleaseList, isAzure]);

  const processBurndownData = () => {
    const isReleaseMode = selectedValue?.value === APP_STRINGS.VALUE_RELEASE;
    const hasSelection = isReleaseMode ? !!selectedRelease?.id : !!selectedSprint?.id;
    if (!hasSelection) return [];

    const hasNewReleaseData = newBurndownData?.sprintBreakdown && 
                               Array.isArray(newBurndownData.sprintBreakdown) &&
                               newBurndownData.sprintBreakdown.length > 0;

    if (isReleaseMode && hasNewReleaseData) {
      return processReleaseBurndownData(newBurndownData);
    }

    if (Array.isArray(newBurndownData?.dailyData) && newBurndownData.dailyData.length > 0) {
      const sprintScope = jiraData?.Sprint ?? jiraData?.Release;
      const burndownPayload = {
        ...newBurndownData,
        startDate: newBurndownData.startDate || sprintScope?.startDate || null,
        endDate: newBurndownData.endDate || sprintScope?.endDate || null,
      };
      return processNewBurndownData({
        burndownData: burndownPayload,
        isStoryPoints,
        jiraData,
        selectedDeveloper,
        getCapacity,
        lastLoggedDate,
        isHoursBasedProject,
      });
    }

    const sprintScope = jiraData?.Sprint;
    const isFutureSprint = String(sprintScope?.state || '').toLowerCase() === 'future';
    if (
      isFutureSprint
      && sprintScope?.startDate
      && sprintScope?.endDate
      && futureScopeHours > 0
    ) {
      const dates = generateDateRange(sprintScope.startDate, sprintScope.endDate);
      const dailyData = dates.map((date) => ({
        date,
        totalOriginalEstimate: futureScopeHours,
        actualLine: futureScopeHours,
        idealLine: futureScopeHours,
      }));
      return processNewBurndownData({
        burndownData: {
          dailyData,
          startDate: sprintScope.startDate,
          endDate: sprintScope.endDate,
          totalOriginalEstimate: futureScopeHours,
          mode: 'sprint',
        },
        isStoryPoints,
        jiraData,
        selectedDeveloper,
        getCapacity,
        lastLoggedDate,
        isHoursBasedProject,
      });
    }

    return [];
  };

  const burndownChartData = processBurndownData();

  const initialEffortByDevMemo = useMemo(() => {
    return jiraData?.Sprint?.idealBurnupByDev || jiraData?.Release?.idealBurnupByDev || [];
  }, [jiraData?.Sprint?.idealBurnupByDev, jiraData?.Release?.idealBurnupByDev]);

  const jiraTableData = jiraData?.jiraTableData;
  const storyChurnData = jiraData?.storyChurnData || [];

  const openPrData = (() => {
    const prsData = jiraTableData?.PRsData || [];

    if (selectedRepos.length === 0 || selectedRepos.length === repoList.length) {
      const aggregatedData = prsData.reduce((acc, prGroup) => {
        const firstPassPRCount = (acc.firstPassPRCount || 0) + (prGroup.firstPassPRCount || 0);
        const totalReviewedMergedPRs =
          (acc.totalReviewedMergedPRs || 0) + (prGroup.totalReviewedMergedPRs || 0);
        return {
          repo: 'All Repositories',
          openReviewedPRs: (acc.openReviewedPRs || 0) + (prGroup.openReviewedPRs || 0),
          openUnreviewedPRs: (acc.openUnreviewedPRs || 0) + (prGroup.openUnreviewedPRs || 0),
          totalMergedPRs: (acc.totalMergedPRs || 0) + (prGroup.totalMergedPRs || 0),
          closedPrs: (acc.closedPrs || 0) + (prGroup.closedPrs || 0),
          totalPrs: (acc.totalPrs || 0) + (prGroup.totalPrs || 0),
          averageTimeToMergeForReviewedPRs:
            acc.averageTimeToMergeForReviewedPRs ||
            prGroup.averageTimeToMergeForReviewedPRs ||
            '0 hrs 0m',
          firstPassPRCount,
          totalReviewedMergedPRs,
          firstPassPRPercent:
            totalReviewedMergedPRs > 0
              ? Math.round((firstPassPRCount / totalReviewedMergedPRs) * 100)
              : 0,
        };
      }, {});
      return aggregatedData;
    } else {
      const filteredData = prsData.filter((prGroup) =>
        selectedRepos.some((repo) => prGroup?.repo?.toLowerCase() === repo.toLowerCase()),
      );

      if (filteredData.length === 1) {
        return filteredData[0];
      } else if (filteredData.length > 1) {
        return filteredData.reduce((acc, prGroup) => {
          const firstPassPRCount = (acc.firstPassPRCount || 0) + (prGroup.firstPassPRCount || 0);
          const totalReviewedMergedPRs =
            (acc.totalReviewedMergedPRs || 0) + (prGroup.totalReviewedMergedPRs || 0);
          return {
            repo: selectedRepos.join(', '),
            openReviewedPRs: (acc.openReviewedPRs || 0) + (prGroup.openReviewedPRs || 0),
            openUnreviewedPRs: (acc.openUnreviewedPRs || 0) + (prGroup.openUnreviewedPRs || 0),
            totalMergedPRs: (acc.totalMergedPRs || 0) + (prGroup.totalMergedPRs || 0),
            closedPrs: (acc.closedPrs || 0) + (prGroup.closedPrs || 0),
            totalPrs: (acc.totalPrs || 0) + (prGroup.totalPrs || 0),
            averageTimeToMergeForReviewedPRs:
              acc.averageTimeToMergeForReviewedPRs ||
              prGroup.averageTimeToMergeForReviewedPRs ||
              '0 hrs 0m',
            firstPassPRCount,
            totalReviewedMergedPRs,
            firstPassPRPercent:
              totalReviewedMergedPRs > 0
                ? Math.round((firstPassPRCount / totalReviewedMergedPRs) * 100)
                : 0,
          };
        }, {});
      } else {
        return {};
      }
    }
  })();


  const rowData = useMemo(() => {
    const fromApi = jiraTableData?.issues;
    let rawIssues = [];
    if (isClickupList) {
      rawIssues =
        Array.isArray(fromApi) && fromApi.length > 0
          ? fromApi
          : Array.isArray(clickupIssuesForTable)
            ? clickupIssuesForTable
            : [];
    } else {
      rawIssues = fromApi || [];
    }

    const milestoneTaskId = isClickupList
      ? resolveClickupMilestoneTaskId(getAllSprintList, selectedSprint?.id)
      : null;
    if (isClickupList && milestoneTaskId) {
      rawIssues = filterClickupIssuesForSelectedMilestone(rawIssues, milestoneTaskId);
    }

    if (isClickupList) {
      return rawIssues.map((issue) => mapClickUpApiIssueToStandupRow(issue)).filter(Boolean);
    }
    return (fromApi || []).map((issue) => mapJiraApiIssueToStandupRow(issue)).filter(Boolean);
  }, [
    jiraTableData?.issues,
    isClickupList,
    clickupIssuesForTable,
    getAllSprintList,
    selectedSprint?.id,
  ]);

  const removedRowData = useMemo(() => {
    if (isClickupList) return [];
    const raw = jiraTableData?.RemovedIssues;
    if (!Array.isArray(raw)) return [];
    return raw.map((issue) => mapJiraApiIssueToStandupRow(issue)).filter(Boolean);
  }, [jiraTableData?.RemovedIssues, isClickupList]);

  const removedRowDataAfterDeveloper = useMemo(() => {
    const afterType = removedRowData.filter((row) =>
      passesChurnIssueTypeFilter(row, selectedOption, excludeBugsInChurn),
    );
    return filterRowsByDeveloper(afterType, selectedDeveloper, isClickupList);
  }, [
    removedRowData,
    selectedOption,
    excludeBugsInChurn,
    selectedDeveloper,
    isClickupList,
  ]);

  // Apply filter from Release Dashboard (issue keys or filterType: openIssues / critical / blockers)
  const rowDataAfterNavFilter = useMemo(() => {
    if (!navigationJiraFilter || !rowData?.length) return rowData;
    const keys = navigationJiraFilter.issueKeys;
    if (Array.isArray(keys) && keys.length > 0) {
      const keySet = new Set(keys.map((k) => String(k).toUpperCase()));
      return rowData.filter((row) => row?.jiraTicket && keySet.has(String(row.jiraTicket).toUpperCase()));
    }
    const type = navigationJiraFilter.filterType;
    if (type === 'openIssues') {
      return rowData.filter((row) => !isDoneLikeStatus(row?.status));
    }
    if (type === 'critical') {
      return rowData.filter((row) => String(row?.priority || '').toLowerCase() === 'critical');
    }
    if (type === 'blockers') {
      return rowData.filter((row) => isJiraRowBlocked(row));
    }
    return rowData;
  }, [rowData, navigationJiraFilter]);

  /** ClickUp: grid rows must respect developer selection client-side (Redux issues are not always pre-filtered). */
  const rowDataAfterDeveloper = useMemo(() => {
    if (!isClickupList || !selectedDeveloper) return rowDataAfterNavFilter;
    if (assigneeLabelIsUnassigned(selectedDeveloper) || isBucketAssigneeName(selectedDeveloper)) {
      return rowDataAfterNavFilter.filter((row) => {
        const a = row?.assignedTo ?? row?.developer;
        return isBucketAssigneeName(a);
      });
    }
    return rowDataAfterNavFilter.filter(
      (row) =>
        isNearbyMatch(selectedDeveloper, row?.assignedTo) ||
        isNearbyMatch(selectedDeveloper, row?.developer),
    );
  }, [isClickupList, selectedDeveloper, rowDataAfterNavFilter]);

  // When navigated from Release page with filter: status badges show counts from filtered table only
  const statusDistributionFromFilteredRows = useMemo(() => {
    if (!navigationJiraFilter || !rowDataAfterNavFilter?.length) return null;
    const statusCounts = {};
    rowDataAfterNavFilter.forEach((row) => {
      const status = row?.status || 'No Status';
      statusCounts[status] = (statusCounts[status] || 0) + 1;
    });
    return Object.entries(statusCounts).map(([status, count]) => ({ status, count }));
  }, [navigationJiraFilter, rowDataAfterNavFilter]);

  const assigneeStoryPoints = {};
  jiraTableData?.issues?.forEach((item) => {
    const assignee = item.assignee || 'UnAssigned';
    const storyPoints = isNaN(item.storyPoints) ? 0 : Number(item.storyPoints);

    if (!assigneeStoryPoints[assignee]) {
      assigneeStoryPoints[assignee] = {
        committed: 0,
        completed: 0,
      };
    }

    if (item.status === 'Closed') {
      assigneeStoryPoints[assignee].completed += storyPoints;
    } else {
      assigneeStoryPoints[assignee].committed += storyPoints;
    }
  });

  Object.keys(assigneeStoryPoints).forEach((assignee) => {
    const { committed, completed } = assigneeStoryPoints[assignee];
    assigneeStoryPoints[assignee].remaining = Math.max(committed - completed, 0);
  });

  assigneeStoryPointList.forEach((item) => {
    if (assigneeStoryPoints[item.assignee]) {
      assigneeStoryPoints[item.assignee].allocatedStoryPoints = item.allocatedStoryPoints;
    }
  });

  /** Date-range (decoupled): API sends all in-window PR details here; legacy paths still flatten from `issues`. */
  const standupPrsFlatForTable =
    Array.isArray(jiraTableData?.standupPullRequestsFlat) && jiraTableData.standupPullRequestsFlat.length > 0
      ? jiraTableData.standupPullRequestsFlat
      : (jiraTableData?.issues || []).flatMap((issue) =>
          Array.isArray(issue.pullRequests) ? issue.pullRequests : [],
        );

  const prRowData = standupPrsFlatForTable
    .map((pr) => {
          const isBySelectedDev = selectedDeveloper
            ? isNearbyMatch(selectedDeveloper, pr.prCreatedBy)
            : true;

          const isInSelectedRepo =
            selectedRepos.length === 0 ||
            selectedRepos.some((repo) => pr?.repo?.toLowerCase() === repo.toLowerCase());

          if (!isBySelectedDev || !isInSelectedRepo) return null;

          let daysOpenValue = 0;
          let daysOpenDisplay = 'NA';
          if (pr.daysOpen !== undefined && pr.daysOpen !== null && pr.daysOpen !== 'NA') {
            if (typeof pr.daysOpen === 'number') {
              daysOpenValue = pr.daysOpen;
              daysOpenDisplay = `${daysOpenValue}`;
            } else if (typeof pr.daysOpen === 'string') {
              const match = pr.daysOpen.match(/\d+/);
              if (match) {
                daysOpenValue = parseInt(match[0], 10);
                daysOpenDisplay = pr.daysOpen;
              }
            }
          } else if (pr.createdAt || pr.prCreatedAt || pr.created_at) {
            const createdAt = pr.createdAt || pr.prCreatedAt || pr.created_at;
            const createdDate = new Date(createdAt);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            createdDate.setHours(0, 0, 0, 0);
            const diffTime = today - createdDate;
            daysOpenValue = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            daysOpenDisplay = daysOpenValue >= 0 ? `${daysOpenValue}` : '0';
          }

          
          const reviewerCount = pr.prReviews?.length ?? 0;
          const reviewerText = reviewerCount > 0
            ? pr.prReviews.map((r) => r.reviewerUsername).join(', ')
            : 'NA';

          let reviewerRange = PR_FILTER_RANGES.REVIEWER.NO_REVIEWERS;
          if (reviewerCount === 1) {
            reviewerRange = PR_FILTER_RANGES.REVIEWER.ONE_REVIEWER;
          } else if (reviewerCount >= 2 && reviewerCount <= 3) {
            reviewerRange = PR_FILTER_RANGES.REVIEWER.TWO_TO_THREE_REVIEWERS;
          } else if (reviewerCount >= 4) {
            reviewerRange = PR_FILTER_RANGES.REVIEWER.FOUR_PLUS_REVIEWERS;
          }

          const filesChanged = pr.filesChanged || 0;
          

          return {
            prId: pr.prNumber,
            title: pr.prTitle !== 'NA' ? pr.prTitle : 'No PR',
            author: pr.prCreatedBy || 'NA',
            status: pr.prStatus || 'No Status',
            daysOpen: daysOpenDisplay,
            daysOpenRange: daysOpenValue, // For filtering
            daysOpenValue: daysOpenValue, // For sorting
            reviewer: reviewerText,
            reviewerRange: reviewerRange, // For filtering
            reviewerCount: reviewerCount, // For sorting
            codeChanges: filesChanged,
            filesChangedRange: filesChanged, // For filtering
            branch: pr.branchName !== 'NA' ? pr.branchName : 'No Branch',
            prUrl: pr.prUrl,
            repo: pr.repo || 'NA',
            merged: ['true', 'merged'].includes(pr?.merged?.toString()?.toLowerCase())
              ? 'Yes'
              : 'No',
            isReviewed: Array.isArray(pr.prReviews) && pr.prReviews.length > 0,
            createdAtStandup: pr.standupPrCreatedAtDisplay ?? 'NA',
            mergedAtStandup: pr.standupPrMergedAtDisplay ?? 'NA',
            closedWithoutMergeAtStandup: pr.standupPrClosedWithoutMergeAtDisplay ?? 'NA',
            firstPassApproved:
              pr.firstPassApproved ??
              (Array.isArray(pr.prReviews) ? isFirstPassApprovedPR(pr.prReviews) : false),
          };
        })
        .filter(Boolean)
    .filter((pr) => {
      if (prFilterType === 'openReviewed') {
        return ['open', 'opened'].includes(pr.status) && pr.isReviewed;
      }
      if (prFilterType === 'openUnreviewed') {
        return ['open', 'opened'].includes(pr.status) && !pr.isReviewed;
      }
      if (prFilterType === 'merged') return pr.merged === 'Yes';
      if (prFilterType === 'totalOpenPRs') return ['open', 'opened'].includes(pr.status);
      if (prFilterType === 'closedPrs') {
        return pr.status === 'closed' && pr.merged === 'No';
      }
      if (prFilterType === 'firstPass') {
        return pr.isReviewed && pr.firstPassApproved;
      }
      return true;
    });

  const includePrDateRangeColumns = isCreatedDateFilterType(selectedValue?.value);

  const filteredPRColumns = useMemo(
    () => PRColumns(jiraTableData?.sourceManagement, includePrDateRangeColumns),
    [jiraTableData?.sourceManagement, includePrDateRangeColumns],
  );

  const statusDistribution = jiraData?.taskCountData?.find((item) => item.statusDistribution)
    ?.statusDistribution?.result;

  const developerStatusChartItems = useMemo(() => {
    const d = jiraDeveloperStatusData;
    if (d == null || d === '') return [];
    if (Array.isArray(d)) {
      if (d.length === 0) return [];
      const first = d[0];
      if (first && typeof first === 'object' && ('status' in first || 'name' in first || 'count' in first)) {
        return d
          .map((item, index) => ({
            status: String(item.status ?? item.name ?? item.key ?? '').trim(),
            count: Number(item.count ?? item.value ?? item.total ?? 0) || 0,
            color: tailwindColors[index % tailwindColors.length],
          }))
          .filter((x) => x.status);
      }
      return [];
    }
    return Object.entries(d).map(([status, count], index) => ({
      status,
      count: typeof count === 'object' && count !== null ? Number(count.count ?? 0) || 0 : Number(count) || 0,
      color: tailwindColors[index % tailwindColors.length],
    }));
  }, [jiraDeveloperStatusData]);

  const statusData = useMemo(() => {
    return statusDistribution
      ? statusDistribution.map((item, index) => ({
          status: item.name,
          count: item.count,
          color: tailwindColors[index % tailwindColors.length],
        }))
      : [];
  }, [statusDistribution]);

  /** Jira: when a developer (including Unassigned) is selected, badge counts must match `jiraTableData.issues` rows — `jiraStatusByDeveloper` can disagree with the table for Release + Unassigned. */
  const jiraDevStatusFromTable = useMemo(() => {
    if (isClickupList || !selectedDeveloper) return null;
    const counts = new Map();
    rowDataAfterNavFilter.forEach((row) => {
      const s = String(row?.status ?? 'No Status').trim() || 'No Status';
      counts.set(s, (counts.get(s) || 0) + 1);
    });
    let idx = 0;
    return Array.from(counts.entries()).map(([status, count]) => ({
      status,
      count,
      color: tailwindColors[idx++ % tailwindColors.length],
    }));
  }, [isClickupList, selectedDeveloper, rowDataAfterNavFilter]);

  const clickupTeamStatusBarData = useMemo(() => {
    if (!isClickupList || selectedDeveloper) return null;
    const counts = new Map();
    rowData.forEach((row) => {
      const s = String(row?.status ?? 'No Status').trim() || 'No Status';
      counts.set(s, (counts.get(s) || 0) + 1);
    });
    let idx = 0;
    return Array.from(counts.entries()).map(([status, count]) => ({
      status,
      count,
      color: tailwindColors[idx++ % tailwindColors.length],
    }));
  }, [isClickupList, selectedDeveloper, rowData]);

  /** ClickUp: when a developer is selected, status badges must match grid rows (`rowDataAfterDeveloper`), not Jira-shaped `jiraDeveloperStatusData`. */
  const clickupDevStatusFromTable = useMemo(() => {
    if (!isClickupList || !selectedDeveloper) return null;
    const counts = new Map();
    rowDataAfterDeveloper.forEach((row) => {
      const s = String(row?.status ?? 'No Status').trim() || 'No Status';
      counts.set(s, (counts.get(s) || 0) + 1);
    });
    let idx = 0;
    return Array.from(counts.entries()).map(([status, count]) => ({
      status,
      count,
      color: tailwindColors[idx++ % tailwindColors.length],
    }));
  }, [isClickupList, selectedDeveloper, rowDataAfterDeveloper]);

  const barChartData = useMemo(() => {
    const filterType = selectedValue?.value;
    const hasScope =
      filterType === APP_STRINGS.VALUE_BACKLOG
        ? true
        : filterType === APP_STRINGS.VALUE_SPRINT
        ? !!(selectedSprint?.id || selectedSprint?.name)
        : filterType === APP_STRINGS.VALUE_RELEASE
          ? !!selectedRelease?.id
          : filterType === APP_STRINGS.VALUE_DATE_RANGE
            ? !!(
                sessionStorage.getItem('standupPrStartDate') &&
                sessionStorage.getItem('standupPrEndDate')
              )
            : false;
    if (!hasScope) return [];

    if (selectedDeveloper) {
      if (!isClickupList) {
        return jiraDevStatusFromTable;
      }
      if (clickupDevStatusFromTable != null && clickupDevStatusFromTable.length > 0) {
        return clickupDevStatusFromTable;
      }
      return developerStatusChartItems.length ? developerStatusChartItems : [];
    }
    if (isClickupList && !selectedDeveloper) {
      return Array.isArray(clickupTeamStatusBarData) ? clickupTeamStatusBarData : [];
    }
    if (statusData?.length) {
      return statusData;
    }
    return developerStatusChartItems.length ? developerStatusChartItems : [];
  }, [
    selectedValue?.value,
    selectedSprint?.id,
    selectedSprint?.name,
    selectedRelease?.id,
    selectedDeveloper,
    statusData,
    developerStatusChartItems,
    isClickupList,
    clickupTeamStatusBarData,
    jiraDevStatusFromTable,
    clickupDevStatusFromTable,
  ]);

  const statusColorMap = useMemo(() => {
    return createColorMapping(barChartData);
  }, [barChartData]);

  const sortedBarChartData = useMemo(() => {
    if (sortOrder === 'default') {
      return barChartData;
    }

    return [...barChartData].sort((a, b) => {
      if (sortOrder === 'asc') {
        return a.count - b.count;
      } else if (sortOrder === 'desc') {
        return b.count - a.count;
      }
      return 0;
    });
  }, [barChartData, sortOrder]);

  const statusBarLeftMargin = useMemo(
    () => getMaxLabelLengthEstimated(sortedBarChartData, 'status'),
    [sortedBarChartData],
  );

  const getStoryPointData = jiraData?.getStoryPointData;
  const getCommittedData = getStoryPointData?.lastFiveData;

  const sprintdata = useMemo(() => {
    return Array.isArray(getCommittedData)
      ? getCommittedData.map((item) => {
          const { name, committedVsCompletedMetrics } = item;
          const m = committedVsCompletedMetrics || {};
          const plannedStoryPoints = Number(m.plannedStoryPoints) || 0;
          const plannedOriginalEstimateHrs = Number(m.plannedOriginalEstimateHrs) || 0;
          return {
            sprint: name,
            committed: committedVsCompletedMetrics?.committedStoryPoints ?? 0,
            committedHours: committedVsCompletedMetrics?.committedHours ?? 0,
            completed: committedVsCompletedMetrics?.completedStoryPoints ?? 0,
            completedHours: committedVsCompletedMetrics?.completedHours ?? 0,
            plannedStoryPoints,
            plannedOriginalEstimateHrs,
          };
        })
      : [];
  }, [getCommittedData]);

  const sprintGoalRechartsPayload = useMemo(() => {
    const chartData = sprintdata.map((item) => ({
      ...item,
      committedDynamic:
        sprintGoalWorkMode === 'without_added_work'
          ? isSprintGoalStoryPoints
            ? item.plannedStoryPoints
            : item.plannedOriginalEstimateHrs
          : isSprintGoalStoryPoints
          ? item.committed
          : item.committedHours,
      completedDynamic: isSprintGoalStoryPoints ? item.completed : item.completedHours,
    }));
    const maxValue = Math.max(
      ...chartData.flatMap((item) => [item.committedDynamic, item.completedDynamic]),
      1,
    );
    const length = sprintdata.length;
    const gaps = {
      1: '20%',
      2: '30%',
      3: '35%',
      4: '38%',
      5: '40%',
    };
    const barCategoryGap = gaps[length] || '40%';
    return { chartData, maxValue, barCategoryGap };
  }, [sprintdata, isSprintGoalStoryPoints, sprintGoalWorkMode]);

  useEffect(() => {
    const companyId = sessionStorage.getItem('companyId');
    if (!companyId) {
      return undefined;
    }

    if (organizationList?.length > 0) {
      setGetAllOrgsList(organizationList);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const orgs = await getAllOrgsListAPI();
        if (cancelled) {
          return;
        }
        const list = Array.isArray(orgs) ? orgs : [];
        if (list.length > 0) {
          dispatch(setOrganizationList(list));
          setGetAllOrgsList(list);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to load organization list for Standup:', error);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, organizationList]);

  // After Login → Admin → Standup: first paint often races loading flags on slow servers.
  // Wait for idle, then ensure Redux has a selected project (retry until set).
  useEffect(() => {
    let cancelled = false;
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const normalizeProjectList = (raw) => {
      if (Array.isArray(raw)) return raw;
      if (Array.isArray(raw?.data)) return raw.data;
      return [];
    };

    const projectInList = (list, id) =>
      (list || []).find((p) => String(p?._id) === String(id || ''));

    const applyLocalProject = (id, name) => {
      if (cancelled || !id) return;
      setSelectedProject({ id: String(id), name: name || '' });
      const board = restoreBoardFromSession();
      if (board) setSelectedBoard(board);
    };

    const bootstrapDefaults = async () => {
      const companyId =
        sessionStorage.getItem('companyId') || sessionStorage.getItem('orgId') || '';
      if (!companyId) return;

      // Phase 1: wait until CommonFunction / Admin→Standup path finishes loading (up to ~12s)
      for (let i = 0; i < 30 && !cancelled; i += 1) {
        const live = store.getState()?.jira || {};
        if (!live.loading && !live.loadingEngMetrics) break;
        await sleep(400);
      }
      if (cancelled) return;

      // Phase 2: ensure a project is selected in Redux + local UI
      for (let attempt = 0; attempt < 8 && !cancelled; attempt += 1) {
        if (attempt > 0) await sleep(500);
        if (cancelled) return;

        const live = store.getState()?.jira || {};
        if (live.loading || live.loadingEngMetrics) continue;

        let list = normalizeProjectList(live.projectList);
        if (list.length === 0) {
          try {
            const res = await getProjectList();
            list = normalizeProjectList(res?.data ?? res);
            if (list.length > 0) dispatch(setProjectList(list));
          } catch (err) {
            console.error('Standup default project list failed:', err);
            continue;
          }
        }

        let projectId =
          live.selectedProjectId || sessionStorage.getItem('projectId') || '';
        let projectDoc = projectInList(list, projectId);
        // Session/login id may not exist in current org list — pick a real default.
        if (!projectDoc) {
          projectDoc = pickDefaultProjectForBootstrap(list);
          projectId = projectDoc?._id ? String(projectDoc._id) : '';
        }
        if (!projectId || !projectDoc) continue;

        const projectName = projectDoc.name || sessionStorage.getItem('projectName') || '';
        sessionStorage.setItem('projectId', projectId);
        sessionStorage.setItem('projectName', projectName);

        if (String(live.selectedProjectId || '') !== projectId || !live.selectedProjectName) {
          dispatch(
            setReduxSelectedProject({
              selectedProjectName: projectName,
              selectedProjectId: projectId,
            }),
          );
        }
        applyLocalProject(projectId, projectName);

        const hasSprintOrRelease =
          Boolean(sessionStorage.getItem('sprintId')) ||
          Boolean(sessionStorage.getItem('releaseId')) ||
          sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE) === APP_STRINGS.VALUE_BACKLOG;
        const hasLists =
          (Array.isArray(live.sprintList) && live.sprintList.length > 0) ||
          (Array.isArray(live.releasesList) && live.releasesList.length > 0);

        if (hasSprintOrRelease && hasLists && live.selectedProjectId) {
          return;
        }

        try {
          const runHandleProject = handleProjectRef.current;
          if (typeof runHandleProject !== 'function') continue;
          await runHandleProject(
            projectId,
            sessionStorage.getItem('boardType') ||
              sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
              '',
            dispatch,
          );
          const after = store.getState()?.jira || {};
          const name =
            after.selectedProjectName ||
            projectInList(normalizeProjectList(after.projectList), after.selectedProjectId)
              ?.name ||
            projectName;
          if (after.selectedProjectId) {
            applyLocalProject(after.selectedProjectId, name);
            return;
          }
        } catch (err) {
          console.error('Standup default project bootstrap failed:', err);
        }
      }
    };

    bootstrapDefaults();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- once per Standup mount; handleProject via ref
  }, []);

  useEffect(() => {
    if (jiraData) {
      setJiraDeveloperStatusData(jiraData.jiraStatusByDeveloper || []);
      setSelectedDeveloper(jiraData.selectedDeveloperName?.value || '');
      const selectedProjects = (jiraData.projectList || []).filter(
        (project) => project.isSelected && project.hideStatus !== true,
      );
      setGetAllProjectList(selectedProjects);
      setSelectedOrg({
        id: jiraData.selectedOrgId || '',
        name: jiraData.selectedOrgName || '',
      });
      setIsOrganizationOpen(jiraData.isOrganizationOpen || false);
    }
  }, [jiraData]);

  const handleOrganizationChange = async (value) => {
    try {
      await handleOrganization(value, dispatch);
    } catch (error) {
      console.error('Error handling organization selection:', error);
    }
  };

  const handleProjectChange = async (value) => {
    try {
      setSelectedStatuses([]);
      setSelectedCategories([]);
      aGridRef.current?.resetFloatingFilter?.();
      setVisibleColumns(fullColumnDefs.filter((col) => !col.optional).map((col) => col.field));
      setIsColumnSelectorOpen(false);
      setPrFilterType('all');
      setSelectedOption('All');

      // Reset board selection when project changes
      setIsBoardOpen(false);
      setSubMenuBoards([]);
      setCurrentProjectForBoard(null);
      setSelectedBoard({ id: '', name: '', type: '' });
      sessionStorage.removeItem('boardId');
      sessionStorage.removeItem('boardScopeProjectId');

      // Fetch boards for the selected project first
      const companyId = getId().companyId;
      const boards = await fetchBoardList(companyId, value);
      
      if (!fetchedProjectIdsRef.current.has(value)) {
        fetchedProjectIdsRef.current.add(value);
        setProjectBoardCount(prev => ({
          ...prev,
          [value]: boards.length
        }));
      }

      // If project has multiple boards, show board selection and auto-select first board
      if (boards.length > 1) {
        // Close submenu immediately when project is clicked
        setIsBoardOpen(false);
        setSubMenuBoards([]);
        setCurrentProjectForBoard(null);

        // Auto-select the first board as fallback
        const firstBoard = boards[0];
        const boardId = firstBoard?.id || firstBoard?._id || '';

        // Find the project details and set selectedProject
        const project = getAllProjectList?.find((p) => p._id === value);
        if (project) {
          setSelectedProject({
            id: project._id,
            name: project.name,
          });

          // Set the first board as selected
          setSelectedBoard({
            id: boardId,
            name: firstBoard?.name || firstBoard?.boardName || '',
            type: firstBoard?.type || firstBoard?.boardType || '',
          });

          // Store boardId in sessionStorage FIRST before making API calls
          sessionStorage.setItem('boardId', boardId);
          sessionStorage.setItem('boardScopeProjectId', String(value));

          // Store board information in sessionStorage for persistence
          storeBoardInSession(
            boardId,
            firstBoard?.name || firstBoard?.boardName || '',
            firstBoard?.type || firstBoard?.boardType || '',
          );

          // Proceed with normal project selection AFTER boardId is stored
          await handleProject(value, firstBoard?.type || firstBoard?.boardType || '', dispatch);
        }

        setClearFiltersSignal((s) => s + 1);
        return; // Don't proceed with the single board logic below
      }

      // Find the project details and set selectedProject
      const project = getAllProjectList?.find((p) => p._id === value);
      if (project) {
        setSelectedProject({
          id: project._id,
          name: project.name,
        });

        // Set the board information if available
        if (boards[0]) {
          const boardId = boards[0]?.id || boards[0]?._id || '';
          setSelectedBoard({
            id: boardId,
            name: boards[0]?.name || boards[0]?.boardName || '',
            type: boards[0]?.type || boards[0]?.boardType || '',
          });

          // Store boardId in sessionStorage FIRST before making API calls
          sessionStorage.setItem('boardId', boardId);
          sessionStorage.setItem('boardScopeProjectId', String(value));

          // Store board information in sessionStorage for persistence
          storeBoardInSession(
            boardId,
            boards[0]?.name || boards[0]?.boardName || '',
            boards[0]?.type || boards[0]?.boardType || '',
          );
        }

        // Proceed with normal project selection AFTER boardId is stored
        await handleProject(value, boards[0]?.type || boards[0]?.boardType || '', dispatch);
      }

      setClearFiltersSignal((s) => s + 1);
    } catch (error) {
      console.error('Error handling project selection:', error);
    }
  };

  // Function to fetch board list for a project
  const fetchBoardList = async (companyId, projectId) => {
    try {
    //   const cachedBoards = jiraData?.boardList;
    //   if (cachedBoards?.length > 0 && projectId === jiraData?.selectedProjectId) {
    //     return cachedBoards;
    const byProject = jiraData?.boardListByProjectId || {};
      const cachedForProject = byProject[String(projectId)];
      if (Array.isArray(cachedForProject) && cachedForProject.length > 0) {
        return cachedForProject;
      }
      const response = await getBoardList(companyId, projectId);
      let boards = [];
      if (response.data) {
        boards = Array.isArray(response.data) ? response.data : [];
      } else if (Array.isArray(response)) {
        boards = response;
      }
           dispatch(setBoardListForProject({ projectId: String(projectId), boards }));
      return boards;
    } catch (error) {
      console.error('Error fetching board list:', error);
      return [];
    }
  };

  // Function to handle board selection
  const handleBoardChange = async (boardId, projectId) => {
    try {
      const selectedBoardData = subMenuBoards.find((board) => (board.id || board._id) === boardId);
      if (selectedBoardData) {
        const currentProject = getAllProjectList?.find((project) => project._id === projectId);
        if (currentProject) {
          sessionStorage.setItem('boardId', boardId || '');
          sessionStorage.setItem('boardScopeProjectId', String(projectId));
          storeBoardInSession(
            boardId || '',
            selectedBoardData.name || selectedBoardData.boardName || '',
            selectedBoardData.type || selectedBoardData.boardType || '',
          );
          setSelectedProject({
            id: currentProject._id,
            name: currentProject.name,
          });
          setSelectedBoard({
            id: boardId || '',
            name: selectedBoardData.name || selectedBoardData.boardName || '',
            type: selectedBoardData.type || selectedBoardData.boardType || '',
          });
          const boardType = selectedBoardData.type || selectedBoardData.boardType;
          await handleProject(projectId, boardType, dispatch);
        }
        setIsBoardOpen(false);
        setSubMenuBoards([]);
        setCurrentProjectForBoard(null);
        setClearFiltersSignal((s) => s + 1);
      }
    } catch (error) {
      console.error('Error handling board selection:', error);
    }
  };

  const handleProjectHover = async (projectId) => {
    try {
        setIsBoardOpen(false);
        setSubMenuBoards([]);
        setCurrentProjectForBoard(null);
        await new Promise((resolve) => setTimeout(resolve, 50));
        const companyId = getId().companyId;       
        const boards = await fetchBoardList(companyId, projectId);        
        if (!fetchedProjectIdsRef.current.has(projectId)) {
          fetchedProjectIdsRef.current.add(projectId);
          setProjectBoardCount(prev => ({
            ...prev,
            [projectId]: boards.length
          }));
        }
        
        if (boards.length > 1) {
          const hoveredElement = document.querySelector(`[data-project-id="${projectId}"]`);
          if (hoveredElement) {
            const rect = hoveredElement.getBoundingClientRect();
            setSubMenuPosition({
              top: rect.top,
              left: rect.right + 10,
            });
          } else {
            setSubMenuPosition({
              top: 100,
              left: 420,
            });
          }
          setSubMenuBoards(boards);
          setCurrentProjectForBoard(projectId);
          setIsBoardOpen(true);
        } else {
          setIsBoardOpen(false);
          setSubMenuBoards([]);
          setCurrentProjectForBoard(null);
        }
      } catch (error) {
        console.error('Error handling project hover:', error);
      }
  };

  const handleProjectMouseLeave = () => {
    setTimeout(() => {
      const submenuElement = document.querySelector('.board-submenu');
      const allProjectElements = document.querySelectorAll('[data-project-id]');
      let isHoveringOverProject = false;
      allProjectElements.forEach((element) => {
        if (element.matches(':hover')) {
          isHoveringOverProject = true;
        }
      });

      if (submenuElement && !submenuElement.matches(':hover') && !isHoveringOverProject) {
        setIsBoardOpen(false);
        setSubMenuBoards([]);
        setCurrentProjectForBoard(null);
      }
    }, 150);
  };

  const getChurnData = useCallback(
    (
      churnTableDataArg,
      selectedValueArg,
      selectedIssueType,
      selectedSprintArg,
      selectedReleaseArg,
    ) => {
      if (!selectedValueArg || !selectedIssueType) return null;
      let entry = null;

      if (selectedValueArg.value === APP_STRINGS.VALUE_SPRINT && selectedSprintArg?.name) {
        entry = churnTableDataArg?.find((e) => e.sprint === selectedSprintArg.name);
      } else if (
        selectedValueArg.value === APP_STRINGS.VALUE_RELEASE &&
        selectedReleaseArg?.releaseName
      ) {
        entry = churnTableDataArg?.find((e) => e.release === selectedReleaseArg.releaseName);
      }

      if (!entry) return null;

      const churnEntry = entry?.churnData?.find((d) => d.issueType === selectedIssueType);
      if (!churnEntry) return null;
      return {
        churnRate: churnEntry.churnRate ?? null,
        planned: churnEntry.planned ?? 0,
        added: churnEntry.added ?? 0,
        removed: churnEntry.removed ?? 0,
      };
    },
    [],
  );

  const sprintScopeIssueKeys = useMemo(() => {
    const scopeData = getActiveScopeData(selectedValue, currentSprint, currentRelease);
    const churnEntries = filterStoryChurnEntries(
      getScopeChurnEntries(scopeData, selectedValue),
      selectedOption,
      excludeBugsInChurn,
    );
    const churnRemoved = mergeChurnIssueKeys(churnEntries, 'removedIssueKeys', selectedDeveloper);
    const removed = new Set(churnRemoved);
    removedRowDataAfterDeveloper.forEach((row) => {
      removed.add(String(row.jiraTicket).toUpperCase());
    });
    return {
      planned: mergeChurnIssueKeys(churnEntries, 'plannedIssueKeys', selectedDeveloper),
      added: mergeChurnIssueKeys(churnEntries, 'addedIssueKeys', selectedDeveloper),
      removed,
    };
  }, [
    selectedValue,
    currentSprint,
    currentRelease,
    selectedOption,
    excludeBugsInChurn,
    selectedDeveloper,
    removedRowDataAfterDeveloper,
  ]);

  const categoryBadgeCounts = useMemo(() => {
    const churnInfo = getChurnData(
      churnTableData,
      selectedValue,
      selectedOption,
      selectedSprint,
      selectedRelease,
    );
    const isFutureSprint = String(currentSprint?.state || '').toLowerCase() === 'future';
    const overdueCount = rowDataAfterDeveloper.filter((row) => isJiraRowOverdue(row)).length;
    const blockerCount = rowDataAfterDeveloper.filter((row) => isJiraRowBlocked(row)).length;
    const plannedFromChurn = churnInfo?.planned ?? 0;
    const plannedCount = sprintScopeIssueKeys.planned.size > 0
      ? sprintScopeIssueKeys.planned.size
      : plannedFromChurn > 0
        ? plannedFromChurn
        : isFutureSprint
          ? rowDataAfterDeveloper.length
          : 0;
    return {
      Overdue: overdueCount,
      Planned: plannedCount,
      Added:
        sprintScopeIssueKeys.added.size > 0
          ? sprintScopeIssueKeys.added.size
          : churnInfo?.added ?? 0,
      Removed:
        sprintScopeIssueKeys.removed.size > 0
          ? sprintScopeIssueKeys.removed.size
          : churnInfo?.removed ?? 0,
      Blocker: blockerCount,
    };
  }, [
    getChurnData,
    churnTableData,
    selectedValue,
    selectedOption,
    selectedSprint,
    selectedRelease,
    rowDataAfterDeveloper,
    sprintScopeIssueKeys,
    currentSprint,
  ]);

  const handleSprintChange = async (value) => {
    try {
      setSelectedStatuses([]);
      setSelectedCategories([]);
      await handleSprint(value, dispatch);
      setClearFiltersSignal((s) => s + 1);
      const selectedSprint = getAllSprintList.find((sprint) => sprint._id === value);
      if (!selectedSprint) {
        console.warn('Selected sprint not found in sprint list');
        return;
      }
      const clickupMilestoneTaskId =
        selectedSprint.clickUpTaskId ??
        selectedSprint.clickupTaskId ??
        selectedSprint.taskId ??
        selectedSprint.clickUpTaskID;
      if (isClickupListBoardTypeFromSession() && clickupMilestoneTaskId) {
        sessionStorage.setItem('sprintId', String(clickupMilestoneTaskId));
      } else {
        sessionStorage.setItem('sprintId', selectedSprint._id);
      }
      sessionStorage.setItem('sprintStartDate', selectedSprint.startDate);
      sessionStorage.setItem('sprintEndDate', selectedSprint.endDate);
      setSelectedSprint({ id: selectedSprint._id, name: selectedSprint.name });
      setSelectedSprintStartDate({
        id: selectedSprint._id,
        startDate: formatStandupDisplayDate(selectedSprint.startDate),
      });
      setSelectedSprintEndDate({
        id: selectedSprint._id,
        endDate: formatStandupDisplayDate(selectedSprint.endDate),
      });
      setIsSprintOpen(false);
      setPrFilterType('all');
      setSelectedOption('All');
    } catch (error) {
      console.error('Error handling sprint selection:', error);
    }
  };

  const handleReleaseChange = async (value) => {
    try {
      setSelectedStatuses([]);
      setSelectedCategories([]);
      await handleRelease(value, dispatch);
      setClearFiltersSignal((s) => s + 1);
      const releaseSelected = getAllReleaseList.find((release) => release._id === value);
      if (!releaseSelected) {
        console.warn('Selected release not found in list');
        return;
      }
      sessionStorage.setItem('releaseName', releaseSelected.releaseName);
      sessionStorage.setItem('releaseDate', releaseSelected.releaseDate);
      setSelectedRelease({ id: releaseSelected._id, releaseName: releaseSelected.releaseName });
      const formattedReleaseDate = releaseSelected.releaseDate
        ? new Date(releaseSelected.releaseDate).toLocaleDateString('en-IN')
        : 'NA';
      const formattedReleaseStartDate = releaseSelected.startDate
        ? new Date(releaseSelected.startDate).toLocaleDateString('en-IN')
        : 'NA';
      setSelectedReleaseDate({
        id: releaseSelected._id,
        startDate: formattedReleaseStartDate,
        releaseDate: formattedReleaseDate,
        overdue: releaseSelected.overdue,
      });
      setPrFilterType('all');
      setSelectedOption('All');
      setIsSprintOpen(false);
    } catch (error) {
      console.error('Error handling release selection:', error);
    }
  };

  const handleRepoChange = async (selectedReposList) => {
    try {
      setSelectedStatuses([]);
      setSelectedCategories([]);
      setSelectedRepos(selectedReposList);
      const primaryRepo = selectedReposList.length > 0 ? selectedReposList[0] : '';
      sessionStorage.setItem('repo', primaryRepo);
      dispatch(setSelectedRepository(primaryRepo));
      setPrFilterType('all');
      setSelectedOption('All');
    } catch (error) {
      console.error('Error handling repo selection:', error);
    }
  };

  const handleValueChange = async (value) => {
    setSelectedStatuses([]);
    setSelectedCategories([]);
    handleValue(value, dispatch);
    setSelectedValue(value);
    dispatch(setSelectedTypeValue({ selectedValueLabel: value.label, selectedValue: value.value }));
    if (value?.value === APP_STRINGS.VALUE_DATE_RANGE) {
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_DATE_RANGE);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_DATE_RANGE);
    }
    dispatch(setSprint(null));
    dispatch(setRelease(null));
    dispatch(setStoryChurnData(null));
    setIsValueOpen(false);
    setSelectedOption('All');
    setSelectedStatuses([]);
    setSelectedCategories([]);
    if (value !== APP_STRINGS.API_SPRINT) {
      setSelectedSprint({ id: '', name: '' });
    }
    if (value?.value !== APP_STRINGS.VALUE_SPRINT) {
      setSelectedSprint({ id: '', name: '' });
    }
    if (value?.value === APP_STRINGS.VALUE_BACKLOG) {
      try {
        await handleBacklogForStandup();
      } catch (error) {
        console.error('Standup backlog fetch failed:', error);
      }
      return;
    }
    const labelKey =
      value?.value === APP_STRINGS.VALUE_SPRINT
        ? APP_STRINGS.API_SPRINT
        : APP_STRINGS.API_RELEASE;
    const initialTypes = (churnTableData || []).reduce((acc, row) => {
      const label = row[labelKey] || row.sprint || row.release;
      acc[label] = 'All';
      return acc;
    }, {});
    setSelectedIssueTypes(initialTypes);
  };

  const handleDateChange = async (newValue) => {
    setSelectedStatuses([]);
    setSelectedCategories([]);
    setValue1(newValue);
    const start = Array.isArray(newValue) ? newValue[0] : null;
    const end = Array.isArray(newValue) ? newValue[1] : null;
    const toYyyyMmDd = (d) => {
      if (!d) return null;
      const x = d instanceof Date ? d : new Date(d);
      if (Number.isNaN(x.getTime())) return null;
      const y = x.getFullYear();
      const m = String(x.getMonth() + 1).padStart(2, '0');
      const day = String(x.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    const startStr = toYyyyMmDd(start);
    const endStr = toYyyyMmDd(end);
    if (startStr && endStr) {
      try {
        await handleDateRangeForStandup(startStr, endStr);
      } catch (e) {
        console.error('Stand-up date range fetch failed:', e);
      }
    } else if (!startStr && !endStr) {
      clearStandupPrDateRange();
      setPrFilterType('all');
    }
  };

  const handleTeamClick = async () => {
    setSelectedStatuses([]);
    setSelectedCategories([]);
    setSelectedDeveloper(null);
    dispatch(setSelectedDeveloperName(null));
    setPrFilterType('all');
    setSelectedOption('All');
    sessionStorage.removeItem('developer');
    setClearFiltersSignal((s) => s + 1);
    try {
      await handleTeam(null, dispatch);
    } catch (error) {
      console.error('Error handling Team selection:', error);
    }
  };

  const handleMultiProjectClick = () => {
    navigate('/multiProjectSelection');
  };

  const dropdownRef = useRef(null);

  const shuffleDevelopers = (list) => {
    const shuffled = [...list];
    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  useEffect(() => {
    if (!randomizeEnabled || assignees.length === 0) return;
    if (Array.isArray(randomizedOrder) && randomizedOrder.length > 0) return;
    const nextOrder = shuffleDevelopers(assignees);
    setRandomizedOrder(nextOrder);
    persistStandupRandomizePreference(true, nextOrder);
  }, [randomizeEnabled, randomizedOrder, assignees]);

  const displayedDevelopers = useMemo(() => {
    const term = searchTerm?.toLowerCase() || '';
    const matchesSearch = (dev) => !term || dev?.toLowerCase().includes(term);

    if (randomizeEnabled && Array.isArray(randomizedOrder)) {
      const assigneeSet = new Set(assignees);
      const frozen = randomizedOrder.filter((dev) => assigneeSet.has(dev));
      const frozenSet = new Set(frozen);
      const extras = assignees.filter((dev) => !frozenSet.has(dev));
      return [...frozen, ...extras].filter(matchesSearch);
    }

    return [...assignees]
      .filter(matchesSearch)
      .sort((a, b) => a.localeCompare(b));
  }, [assignees, searchTerm, randomizeEnabled, randomizedOrder]);

  const handleDeveloperSelect = async (developer) => {
    setSelectedStatuses([]);
    setSelectedCategories([]);
    setSelectedDeveloper(developer);
    dispatch(setSelectedDeveloperName(developer));
    setAssigneeIsOpen(false);
    setSearchTerm('');
    setPrFilterType('all');
    setSelectedOption('All');
    try {
      await handleDeveloper(developer, dispatch);
      setClearFiltersSignal((s) => s + 1);
    } catch (error) {
      console.error('Error handling developer selection:', error);
    }
  };

  const toggleRandomize = () => {
    if (randomizeEnabled) {
      setRandomizeEnabled(false);
      setRandomizedOrder(null);
      persistStandupRandomizePreference(false, null);
      return;
    }
    const nextOrder = shuffleDevelopers(assignees);
    setRandomizeEnabled(true);
    setRandomizedOrder(nextOrder);
    persistStandupRandomizePreference(true, nextOrder);
  };

  const handleViewCapacityDetails = () => {
    navigate('/capacityPlanning');
  };

  const handleCloseDetails = () => {
    setShowChurnDetails(false);
    const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
    const initialTypes = (churnTableData || []).reduce((acc, row) => {
      const label = row[labelKey] || row.sprint || row.release;
      acc[label] = 'All';
      return acc;
    }, {});
    setSelectedIssueTypes(initialTypes);
  };

  const handleViewChurnDetails = () => {
    setShowChurnDetails(true);
    const labelKey = selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? APP_STRINGS.API_SPRINT : APP_STRINGS.API_RELEASE;
    const initialTypes = (churnTableData || []).reduce((acc, row) => {
      const label = row[labelKey] || row.sprint || row.release;
      acc[label] = selectedOption || 'All';
      return acc;
    }, {});
    setSelectedIssueTypes(initialTypes);
  };

  const toggleStatus = (status) => {
    setSelectedStatuses((prev) => {
      const isCurrentlySelected = prev.includes(status);
      return isCurrentlySelected ? prev.filter((s) => s !== status) : [...prev, status];
    });
  };

  const toggleCategory = (category) => {
    setSelectedCategories((prev) => {
      const isCurrentlySelected = prev.includes(category);
      return isCurrentlySelected ? prev.filter((c) => c !== category) : [...prev, category];
    });
  };

  const handleStatusCarouselNext = () => {
    if (isStatusAtEnd) return;
    const itemsToScroll = visibleBadgeCount > 0 ? visibleBadgeCount : statusItemsPerPage;
    setStatusCarouselIndex((prev) => prev + itemsToScroll);
  };

  const handleStatusCarouselPrev = () => {
    if (isStatusAtStart) return;
    const itemsToScroll = visibleBadgeCount > 0 ? visibleBadgeCount : statusItemsPerPage;
    setStatusCarouselIndex((prev) => Math.max(0, prev - itemsToScroll));
  };

  const statusBadgeData = useMemo(() => {
    const source =
      navigationJiraFilter && statusDistributionFromFilteredRows?.length
        ? statusDistributionFromFilteredRows
        : barChartData;
    return (source || []).filter((item) => item.status !== 'Overdue');
  }, [navigationJiraFilter, statusDistributionFromFilteredRows, barChartData]);

  const effectiveItemsPerPage = visibleBadgeCount > 0 ? visibleBadgeCount : statusItemsPerPage;

  const safeStatusStart = Math.max(
    0,
    Math.min(statusCarouselIndex, statusBadgeData.length - 1),
  );
  const isStatusAtStart = safeStatusStart === 0;

  const isStatusAtEnd = safeStatusStart + effectiveItemsPerPage >= statusBadgeData.length;

  /** PR-calendar date range had no workflow counts; badges were hidden. Issue-created range has rows + `jiraStatusByDev` — show badges when `prDateRangeActive` is false. */
  const hideStatusBadgesForPrOnlyDateRange =
    isCreatedDateFilterType(selectedValue?.value) && jiraTableData?.prDateRangeActive === true;

  const shouldShowArrows =
    !hideStatusBadgesForPrOnlyDateRange && statusBadgeData.length > effectiveItemsPerPage;

  const getVisibleStatusItems = () => {
    if (hideStatusBadgesForPrOnlyDateRange) {
      return [];
    }
    const endIndex = Math.min(
      safeStatusStart + effectiveItemsPerPage,
      statusBadgeData.length,
    );
    const visibleItems = statusBadgeData.slice(safeStatusStart, endIndex);
    return visibleItems;
  };

  useEffect(() => {
    if (statusBadgeData.length > 0) {
      setStatusCarouselIndex(0);
    }
  }, [statusBadgeData.length]);

  useEffect(() => {
    const calculateVisibleBadges = () => {
      if (!statusCarouselContainerRef.current || statusBadgeData.length === 0) {
        setVisibleBadgeCount(statusBadgeData.length);
        return;
      }

      const container = statusCarouselContainerRef.current;
      const containerWidth = container.clientWidth;

      const buttonSpace = 70;
      const padding = 40;
      const gapBetweenBadges = 8;

      let totalWidthNeeded = 0;

      for (let i = 0; i < statusBadgeData.length; i++) {
        const badge = statusBadgeData[i];
        const text = `${badge.count} ${badge.status}`;
        const estimatedBadgeWidth = text.length * 7 + 52;
        totalWidthNeeded += estimatedBadgeWidth + (i > 0 ? gapBetweenBadges : 0);
      }

      const availableWidthWithoutArrows = containerWidth - buttonSpace - padding;

      if (totalWidthNeeded <= availableWidthWithoutArrows) {
        setVisibleBadgeCount((prevCount) => {
          if (prevCount !== statusBadgeData.length && prevCount > 0) {
            setStatusCarouselIndex(0);
          }
          return statusBadgeData.length;
        });
        return;
      }

      const arrowSpace = 32 * 2 + 24;
      const availableWidthWithArrows = containerWidth - arrowSpace - buttonSpace - padding;

      let totalWidth = 0;
      let visibleCount = 0;

      for (let i = 0; i < statusBadgeData.length; i++) {
        const badge = statusBadgeData[i];
        const text = `${badge.count} ${badge.status}`;
        const estimatedBadgeWidth = text.length * 7 + 52;

        if (
          totalWidth + estimatedBadgeWidth + (visibleCount > 0 ? gapBetweenBadges : 0) <=
          availableWidthWithArrows
        ) {
          totalWidth += estimatedBadgeWidth + (visibleCount > 0 ? gapBetweenBadges : 0);
          visibleCount++;
        } else {
          break;
        }
      }

      const finalCount = Math.max(1, visibleCount);

      setVisibleBadgeCount((prevCount) => {
        if (prevCount !== finalCount && prevCount > 0) {
          setStatusCarouselIndex(0);
        }
        return finalCount;
      });
    };

    calculateVisibleBadges();

    window.addEventListener('resize', calculateVisibleBadges);
    return () => window.removeEventListener('resize', calculateVisibleBadges);
  }, [statusBadgeData, statusCarouselContainerRef]);

  const rowMatchesCategory = useCallback(
    (row, category) => {
      if (category === 'Overdue') return isJiraRowOverdue(row);
      if (category === 'Blocker') return isJiraRowBlocked(row);
      const flags = row.scopeFlags || {};
      if (category === 'Planned') {
        return sprintScopeIssueKeys.planned.size > 0
          ? rowMatchesScopeIssueKey(row, sprintScopeIssueKeys.planned)
          : flags.isPlanned;
      }
      if (category === 'Added') {
        return sprintScopeIssueKeys.added.size > 0
          ? rowMatchesScopeIssueKey(row, sprintScopeIssueKeys.added)
          : flags.isAdded;
      }
      if (category === 'Removed') {
        return sprintScopeIssueKeys.removed.size > 0
          ? rowMatchesScopeIssueKey(row, sprintScopeIssueKeys.removed)
          : flags.isRemoved;
      }
      return false;
    },
    [sprintScopeIssueKeys],
  );

  const filteredRowData = useMemo(() => {
    let data = rowDataAfterDeveloper;
    if (!selectedStatuses.length && !selectedCategories.length) {
      return data;
    }

    const project = getAllProjectList?.find((p) => p._id === selectedProject.id);
    const isGitLabProject = project?.projectTypeKey === 'gitlab-project';
    const isPlannedSelected = selectedCategories.includes('Planned');
    const isAddedSelected = selectedCategories.includes('Added');
    const isRemovedSelected = selectedCategories.includes('Removed');

    const matchedFromMain = data.filter((row) => {
      let matchesStatus = true;
      if (selectedStatuses.length) {
        if (isGitLabProject) {
          matchesStatus =
            (row?.labels && selectedStatuses.includes(row.labels)) ||
            selectedStatuses.includes(row.status);
        } else if (isClickupList) {
          const rs = String(row?.status ?? '').trim();
          matchesStatus = selectedStatuses.some(
            (s) => String(s).trim().toLowerCase() === rs.toLowerCase(),
          );
        } else {
          matchesStatus = selectedStatuses.includes(row.status);
        }
      }

      let matchesCategory = true;
      if (selectedCategories.length) {
        matchesCategory = selectedCategories.some((category) => rowMatchesCategory(row, category));
      }

      return matchesStatus && matchesCategory;
    });

    let result = matchedFromMain;

    if (isPlannedSelected && removedRowDataAfterDeveloper.length > 0) {
      result = mergeRemovedRowsIntoResults(
        result,
        removedRowDataAfterDeveloper,
        sprintScopeIssueKeys.planned,
      );
    }
    if (isAddedSelected && removedRowDataAfterDeveloper.length > 0) {
      result = mergeRemovedRowsIntoResults(
        result,
        removedRowDataAfterDeveloper,
        sprintScopeIssueKeys.added,
      );
    }
    if (isRemovedSelected && removedRowDataAfterDeveloper.length > 0) {
      result = mergeRemovedRowsIntoResults(result, removedRowDataAfterDeveloper);
    }

    return result;
  }, [
    rowDataAfterDeveloper,
    selectedStatuses,
    selectedCategories,
    getAllProjectList,
    selectedProject.id,
    isClickupList,
    rowMatchesCategory,
    removedRowDataAfterDeveloper,
    sprintScopeIssueKeys,
  ]);

  /** Legacy: PR-calendar date range used synthetic rows; main Jira grid was hidden. Issue-created date range returns real issues (`prDateRangeActive: false`) and must show the grid. */
  const hideJiraIssuesGridForPrOnlyDateRange =
    isCreatedDateFilterType(selectedValue?.value) && jiraTableData?.prDateRangeActive === true;

  const displayFilteredRowData = hideJiraIssuesGridForPrOnlyDateRange ? [] : filteredRowData;

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      sortIcon: true,
      sortingOrder: ['asc', 'desc'],
      resizable: true,
      flex: 1,
      tooltipShowDelay: 0,
      floatingFilterComponent: SearchFloatingFilter,
      floatingFilterComponentParams: {
        gridApi: gridApiRef.current,
      },
    }),
    [gridApiRef],
  );
  const handleFilterIconClick = useCallback((field) => {
    const floatingFilter = gridApiRef.current?.getFloatingFilterComponent(field);
    floatingFilter?.getGui()?.focus();
  }, []);

  const columnDefsWithApi = useMemo(() => {
    const sampleCustomFields =
      filteredRowData.length > 0
        ? filteredRowData.reduce((acc, row) => {
            return { ...acc, ...(row.customFieldsByName || {}) };
          }, {})
        : (jiraTableData?.issues || []).reduce((acc, issue) => {
            return { ...acc, ...(issue.customFieldsByName || {}) };
          }, {});
    return jiraColumnDefs(
      handleFilterIconClick,
      sampleCustomFields,
      jiraTableData?.sourceManagement,
      isClickupList,
       `${String(sprintLabel).toUpperCase()} OUTCOMES`,
      isGithubIssues,
    )?.map((colDef) => {
      const isSearchFloating = colDef.floatingFilterComponent === SearchFloatingFilter;

      return {
        ...colDef,
        floatingFilterComponentParams: {
          ...(isSearchFloating ? { gridApi: gridApiRef.current } : {}),
        },
      };
    });
  }, [
    gridApiRef,
    filteredRowData,
    handleFilterIconClick,
    jiraTableData,
    isClickupList,
    sprintLabel,
    isGithubIssues,
  ]);

  const onJiraGridApiReady = useCallback((api) => {
    gridApiRef.current = api;
    api.onFilterChanged();
  }, []);

  const onPRGridReady = useCallback((api) => {
    prGridApiRef.current = api;
  }, []);

  const onFilterChanged = () => {
    gridApiRef.current.onFilterChanged();
  };
  useEffect(() => {
    const updateItemsPerPage = () => {
      setStatusItemsPerPage(4);
    };

    updateItemsPerPage();

    let resizeObserver;
    if (window.ResizeObserver && statusCarouselContainerRef.current) {
      resizeObserver = new ResizeObserver(updateItemsPerPage);
      resizeObserver.observe(statusCarouselContainerRef.current);
    } else {
      window.addEventListener('resize', updateItemsPerPage);
    }

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      else window.removeEventListener('resize', updateItemsPerPage);
    };
  }, [statusBadgeData]);

  const fullColumnDefs = useMemo(() => {
    const sampleCustomFields =
      filteredRowData.length > 0 ? filteredRowData[0].customFieldsByName : {};
//     return jiraColumnDefs(
//       handleFilterIconClick,
//       sampleCustomFields,
//       undefined,
//       isClickupList,
//     );
//   }, [handleFilterIconClick, filteredRowData, isClickupList]);
 return jiraColumnDefs(
      handleFilterIconClick,
      sampleCustomFields,
      jiraTableData?.sourceManagement,
      isClickupList,
      `${String(sprintLabel).toUpperCase()} OUTCOMES`,
      isGithubIssues,
    );
  }, [handleFilterIconClick, filteredRowData, jiraTableData?.sourceManagement, sprintLabel, isClickupList, isGithubIssues]);

  const [visibleColumns, setVisibleColumns] = useState(() => {
    return fullColumnDefs.filter((col) => !col.optional).map((col) => col.field);
  });

  const allColumns = useMemo(() => {
    const hasDeveloperData = filteredRowData?.some(
      (row) => row.developer && row.developer !== 'Unassigned',
    );
    return fullColumnDefs.filter(
      (col) =>
        col.allowToggle
        && (col.field !== 'developer' || hasDeveloperData)
        && (!isBacklogMode || col.field !== 'sprintOutcome'),
    );
  }, [fullColumnDefs, filteredRowData, isBacklogMode]);

  const displayVisibleColumns = useMemo(() => {
    if (isBacklogMode) {
      return visibleColumns.filter((field) => field !== 'sprintOutcome');
    }
    return visibleColumns;
  }, [visibleColumns, isBacklogMode]);

  useEffect(() => {
    if (isBacklogMode) {
      setVisibleColumns((prev) => prev.filter((field) => field !== 'sprintOutcome'));
      setSelectedCategories([]);
    }
  }, [isBacklogMode]);

  const handleColumnToggle = (field) => {
    const isCurrentlyVisible = visibleColumns.includes(field);
    const canHideColumn = visibleColumns.length > 1;
    const willBeVisible = !isCurrentlyVisible;

    const newVisibleColumns = isCurrentlyVisible
      ? canHideColumn
        ? visibleColumns.filter((f) => f !== field)
        : visibleColumns
      : [...visibleColumns, field];
    setVisibleColumns(newVisibleColumns);
    if (aGridRef.current?.clearExternalFilter) {
      aGridRef.current.clearExternalFilter(field);
    }
    if (gridApiRef.current?.columnApi) {
      gridApiRef.current.columnApi.setColumnVisible(field, willBeVisible);
    }

    if (isCurrentlyVisible && canHideColumn && gridApiRef.current) {
      const filterModel = gridApiRef.current.getFilterModel();
      const isFilterApplied = Object.prototype.hasOwnProperty.call(filterModel, field);

      if (isFilterApplied) {
        const filterInstance = gridApiRef.current.getFilterInstance(field);
        if (filterInstance) {
          filterInstance.setModel(null);
        }

        const floatingFilterComponent = gridApiRef.current.getFloatingFilterComponent(field);
        if (floatingFilterComponent) {
          floatingFilterComponent.onFloatingFilterChanged({
            model: null,
            filterInstance,
          });
        }

        gridApiRef.current.onFilterChanged();
        gridApiRef.current.refreshHeader();
        setClearFiltersSignal((prev) => prev + 1);
        if (aGridRef.current && aGridRef.current.clearExternalFilter) {
          aGridRef.current.clearExternalFilter(field);
        }
      }
    }
  };

  const handleColumnsClearAll = useCallback(() => {
    const requiredColumns = fullColumnDefs
      .filter((col) => !col.optional)
      .map((col) => col.field);
    setVisibleColumns(requiredColumns);
    if (gridApiRef.current?.columnApi) {
      allColumns.forEach((col) => {
        const shouldBeVisible = requiredColumns.includes(col.field);
        gridApiRef.current.columnApi.setColumnVisible(
          col.field,
          shouldBeVisible,
        );
      });
    }
  }, [fullColumnDefs, allColumns]);

  // For testing purposes we are using this change. If this endpoint works properly, we will remove the commented code later.
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const fetchedStoryPoints = await getRoleRatesAndStoryPoints(companyId);
  //       const storyPoints = fetchedStoryPoints?.storyPoints ?? 8;
  //       setStoryPoints(storyPoints);
  //       const projectId = getId().projectId;
  //       const response = await axiosInstance.get(
  //         `/api/jira/getLastSynced/${companyId}/${projectId}`,
  //       );
  //       const rawDate = response?.data?.lastSynced.split(',')[0];
  //       const [day, month, year] = rawDate.split('/');
  //       setLastLoggedDate(`${year}-${month}-${day}`);
  //     } catch (error) {
  //       console.error('Error during companyId-related fetches:', error);
  //     }
  //   };
  //   fetchData();
  // }, [companyId]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getStandupDashboardData({
          value:
            sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE) === APP_STRINGS.VALUE_RELEASE
              ? APP_STRINGS.API_RELEASE
              : APP_STRINGS.API_SPRINT,
          sections: 'roleRatesAndStoryPoints,lastSynced',
        });
        const data = response?.data;
        if (data?.roleRatesAndStoryPoints) {
          const sp = data.roleRatesAndStoryPoints?.storyPoints ?? 8;
          setStoryPoints(sp);
        }
        if (data?.lastSynced) {
          const rawDate = data.lastSynced?.lastSynced?.split(',')[0];
          if (rawDate) {
            const [day, month, year] = rawDate.split('/');
            setLastLoggedDate(`${year}-${month}-${day}`);
          }
        }
      } catch (error) {
        console.error('Error during companyId-related fetches:', error);
      }
    };
    fetchData();
  }, [companyId, refreshToken]);

  useEffect(() => {
    if (!companyId) return;

    dispatch(setMultiProjectCompanyId(companyId));

    if (
      multiProjectFilters?.projects?.length > 0 &&
      multiProjectCompanyId === companyId
    ) {
      return;
    }

    // Defer until sprint/release auto-selection finishes so it does not compete for API bandwidth.
    if (jiraData?.loadingEngMetrics) return;
    const hasScopeSelection =
      sessionStorage.getItem('sprintId') || sessionStorage.getItem('releaseId');
    if (!hasScopeSelection) return;

    let cancelled = false;
    let idleCallbackId;
    let timeoutId;

    const prefetchMultiProjectFilters = async () => {
      try {
        const typeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
        const value =
          typeValue === APP_STRINGS.VALUE_RELEASE
            ? APP_STRINGS.API_RELEASE
            : APP_STRINGS.API_SPRINT;
        const response = await getStandupDashboardData({
          value,
          sections: 'getmultiProjectfilters',
        });
        if (!cancelled && response?.data?.getmultiProjectfilters) {
          const scoped = scopeMultiProjectFiltersByAccessibleProjects(
            response.data.getmultiProjectfilters,
            jiraData?.projectList || getAllProjectList || [],
          );
          dispatch(setMultiProjectFilters(scoped));
        }
      } catch (err) {
        console.warn('Could not prefetch multi-project filters:', err);
      }
    };

    if (typeof window.requestIdleCallback === 'function') {
      idleCallbackId = window.requestIdleCallback(() => prefetchMultiProjectFilters(), {
        timeout: 3000,
      });
    } else {
      timeoutId = setTimeout(prefetchMultiProjectFilters, 1500);
    }

    return () => {
      cancelled = true;
      if (idleCallbackId != null && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleCallbackId);
      }
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }, [
    companyId,
    dispatch,
    jiraData?.loadingEngMetrics,
    jiraData?.selectedSprintId,
    jiraData?.selectedReleaseId,
    jiraData?.projectList,
    getAllProjectList,
    multiProjectFilters?.projects?.length,
    multiProjectCompanyId,
  ]);

  useEffect(() => {
    if (!companyId) return;
    const cached = jiraData?.holidayListByCompanyId?.[companyId];
    if (Array.isArray(cached)) return;

    let cancelled = false;
    (async () => {
      try {
        const holidayData = await getHolidayList();
        const fetchedHolidays = holidayData?.holidayList || [];
        if (!cancelled) {
          dispatch(setHolidayListForCompany({ companyId, holidays: fetchedHolidays }));
        }
      } catch (error) {
        console.warn('Could not load holiday list for standup capacity:', error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [companyId, dispatch, jiraData?.holidayListByCompanyId]);
  useEffect(() => {
  if (!getAllProjectList || !jiraData?.selectedProjectId) {
    setRepoSource('No repositories found or project not matched.');
    return;
  }

  const getMatchingProject = getAllProjectList.find(
    (project) => project?._id === jiraData?.selectedProjectId,
  );

  if (getMatchingProject?.repos && Array.isArray(getMatchingProject.repos)) {
    const isGitLab = getMatchingProject.repos.some(
      (repo) => typeof repo === 'string' && repo.includes('gitlab.com'),
    );
    const isGitHub = getMatchingProject.repos.some(
      (repo) => typeof repo === 'string' && repo.includes('github.com'),
    );
    const isCodeCommit = getMatchingProject.repos.some(
      (repo) => typeof repo === 'string' && repo.includes('git-codecommit'),
    );

    if (isGitLab) {
      setRepoSource('GitLab');
    } else if (isGitHub) {
      setRepoSource('GitHub');
    } else if (isCodeCommit) {
      setRepoSource('AWS CodeCommit');
    } else {
      setRepoSource('unknown');
    }
    
  } else {
    setRepoSource('No repositories found or project not matched.');
  }
}, [getAllProjectList, jiraData?.selectedProjectId]);
  const prLabel = repoSource?.toLowerCase() === 'gitlab' ? 'Merge Requests' : 'Pull Requests';
  const prShortLabel = repoSource?.toLowerCase() === 'gitlab' ? 'MR' : 'PR';
  const prPluralShortLabel = `${prShortLabel}s`;
  const prSummaryTooltip = buildStandupPRSummaryTooltip({
    prLabel,
    prPluralShortLabel,
    prShortLabel,
  });

  useEffect(() => {
    if (jiraData) {
      setJiraDeveloperStatusData(jiraData.jiraStatusByDeveloper || []);
      setLoading(jiraData.loadingEngMetrics || false);
      setSelectedSprint({
        id: jiraData.selectedSprintId || '',
        name: jiraData.selectedSprintName || '',
      });
      setSelectedRelease({
        id: jiraData.selectedReleaseId || '',
        releaseName: jiraData.selectedReleaseName || '',
      });
      setSelectedValue({
        label: jiraData.selectedValueLabel || APP_STRINGS.SELECT_AN_OPTION,
        value: jiraData.selectedValue || '',
      });
      setCurrentSprint(jiraData.Sprint);
      setCurrentRelease(jiraData.Release);
      setGetAllSprintList(jiraData.sprintList || []);
      setGetAllReleaseList(jiraData.releasesList || []);
      setSelectedProject({
        id: jiraData.selectedProjectId || '',
        name:
          jiraData.selectedProjectName ||
          (Array.isArray(jiraData.projectList)
            ? jiraData.projectList.find(
                (p) => String(p?._id) === String(jiraData.selectedProjectId || ''),
              )?.name
            : '') ||
          sessionStorage.getItem('projectName') ||
          '',
      });
      setSelectedOrg({
        id: jiraData.selectedOrgId || '',
        name: jiraData.selectedOrgName || '',
      });
      setIsOrganizationOpen(jiraData.isOrganizationOpen || false);

      const restoredDeveloper = jiraData.selectedDeveloperName?.value || '';
      const sessionDev = sessionStorage.getItem('developer');
      if (restoredDeveloper && selectedDeveloper !== restoredDeveloper) {
        setSelectedDeveloper(restoredDeveloper);
        if (sessionDev !== restoredDeveloper) {
          sessionStorage.setItem('developer', restoredDeveloper);
        }
      } else if (!restoredDeveloper) {
        const hadStaleSessionDev = !!sessionDev;
        if (selectedDeveloper) {
          setSelectedDeveloper(null);
        }
        if (sessionDev) {
          sessionStorage.removeItem('developer');
        }
        if (
          hadStaleSessionDev &&
          (jiraData?.selectedSprintId || jiraData?.selectedReleaseId)
        ) {
          void handleTeam(null, dispatch);
        }
      }

      const restoredBoard = restoreBoardFromSession();
      if (restoredBoard) {
        setSelectedBoard(restoredBoard);
      }
      setIsProjectOpen(jiraData.isProjectOpen || false);
      setIsSprintOpen(jiraData.isSprintOpen || false);
      setRepoList(jiraData.repoList || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jiraData, gitData, selectedRepos]);

  useEffect(() => {
    if (repoList.length > 0) {
      setSelectedRepos(repoList);
    } else {
      setSelectedRepos([]);
    }
  }, [repoList]);

  useEffect(() => {
    const isBacklogSelection = selectedValue?.value === APP_STRINGS.VALUE_BACKLOG;
    const hasSelection = isBacklogSelection
      || (selectedValue?.value === APP_STRINGS.VALUE_RELEASE
        ? !!selectedRelease?.id
        : !!selectedSprint?.id);
    if (!hasSelection) {
      setAssigneeStoryPointList([]);
      setAssignees([]);
      setClickupIssuesForTable(null);
      setAvailableCapacity(0);
      setAllocatedCapacity(0);
      setRemainingCapacity(0);
      setIsRemainingNegative(false);
      setOverloadCount(0);
      setUnderloadCount(0);
      return;
    }

    const useClickupIssuesForAssignees =
      isClickupList &&
      selectedValue?.value !== APP_STRINGS.VALUE_RELEASE &&
      !!selectedSprint?.id;

    if (useClickupIssuesForAssignees) {
      let cancelled = false;
      (async () => {
        try {
          const res = await getClickUpIssues();
          if (cancelled) return;
          let issues = Array.isArray(res?.data) ? res.data : [];
          const milestoneTaskId = resolveClickupMilestoneTaskId(getAllSprintList, selectedSprint?.id);
          if (milestoneTaskId) {
            issues = filterClickupIssuesForSelectedMilestone(issues, milestoneTaskId);
          }
          setClickupIssuesForTable(issues);
          const uniqueNames = [
            ...new Set(
              issues
                .map((i) => (i.assignee != null ? String(i.assignee).trim() : ''))
                .filter((n) => n !== ''),
            ),
          ].sort((a, b) => a.localeCompare(b));

          const allocatedByAssignee = new Map();
          issues.forEach((issue) => {
            if (issue.assignee == null || String(issue.assignee).trim() === '') return;
            const name = String(issue.assignee).trim();
            const est = Number(issue.originalEstimateHrs) || 0;
            const spent = Number(issue.timeSpentHrs) || 0;
            const add = est > 0 ? est : spent;
            allocatedByAssignee.set(name, (allocatedByAssignee.get(name) || 0) + add);
          });

          const assigneeStoryPointListFromIssues = uniqueNames.map((assignee) => ({
            assignee,
            allocatedStoryPoints: allocatedByAssignee.get(assignee) || 0,
            availableHours: 0,
          }));

          setAssigneeStoryPointList(assigneeStoryPointListFromIssues);
          setAssignees(uniqueNames);
          setIsHoursBasedProject(true);
          sessionStorage.setItem('isHoursBasedProject', 'true');

          const totalAllocatedCapacity = assigneeStoryPointListFromIssues.reduce(
            (sum, item) => sum + (item.allocatedStoryPoints || 0),
            0,
          );

          let availableForSelectedDev = 0;
          let allocatedForSelectedDev = 0;
          let remainingForSelectedDev = 0;
          if (selectedDeveloper) {
            const selectedDevData = assigneeStoryPointListFromIssues.find(
              (dev) => dev.assignee === selectedDeveloper,
            );
            if (selectedDevData) {
              availableForSelectedDev = selectedDevData.availableHours || 0;
              allocatedForSelectedDev = selectedDevData.allocatedStoryPoints || 0;
              remainingForSelectedDev = availableForSelectedDev - allocatedForSelectedDev;
            }
          }

          const commonAvailablePoints = selectedDeveloper
            ? availableForSelectedDev
            : assigneeStoryPointListFromIssues.reduce((s, i) => s + (i.availableHours || 0), 0);
          const commonAllocatedPoints = selectedDeveloper
            ? allocatedForSelectedDev
            : totalAllocatedCapacity;
          const commonRemainingPoints = selectedDeveloper
            ? remainingForSelectedDev
            : commonAvailablePoints - totalAllocatedCapacity;

          setAvailableCapacity(Number(commonAvailablePoints.toFixed(2)));
          setAllocatedCapacity(Number(commonAllocatedPoints.toFixed(2)));
          setRemainingCapacity(Number(commonRemainingPoints.toFixed(2)));
          setIsRemainingNegative(commonRemainingPoints < 0);
          setOverloadCount(0);
          setUnderloadCount(0);
        } catch (err) {
          if (cancelled) return;
          console.error('Failed to load ClickUp issues for assignees:', err);
          setClickupIssuesForTable(null);
          const userList = jiraData?.userList || [];
          setAssignees(userList.map((a) => a.displayName));
          setAssigneeStoryPointList([]);
          setAvailableCapacity(0);
          setAllocatedCapacity(0);
          setRemainingCapacity(0);
          setIsRemainingNegative(false);
          setOverloadCount(0);
          setUnderloadCount(0);
        }
      })();
      return () => {
        cancelled = true;
      };
    }

    setClickupIssuesForTable(null);

    if (isBacklogSelection) {
      const fromApi = Array.isArray(jiraData?.jiraTableData?.backlogAssignees)
        ? jiraData.jiraTableData.backlogAssignees
        : [];
      const developerNames = (
        fromApi.length > 0
          ? fromApi
              .map((n) => String(n || '').trim())
              .filter((n) => {
                if (!n) return false;
                // Keep Unassigned for backlog dropdown; drop other bucket labels (none, n/a).
                if (isUnassignedBucketName(n)) return true;
                return !isBucketAssigneeName(n);
              })
              .map((n) => (isUnassignedBucketName(n) ? 'Unassigned' : n))
          : (() => {
              // Fallback only if API has not sent backlogAssignees yet
              const backlogIssues = Array.isArray(jiraData?.jiraTableData?.issues)
                ? jiraData.jiraTableData.issues
                : [];
              const nameSet = new Set();
              for (const issue of backlogIssues) {
                const name = normalizeIssueAssigneeName(issue);
                if (!name) {
                  continue;
                }
                if (isUnassignedBucketName(name)) {
                  nameSet.add('Unassigned');
                  continue;
                }
                if (isBucketAssigneeName(name)) {
                  continue;
                }
                nameSet.add(name);
              }
              return [...nameSet];
            })()
      )
        .filter((n, i, arr) => arr.indexOf(n) === i)
        .sort((a, b) => a.localeCompare(b));
      setAssignees(developerNames);
      setAssigneeStoryPointList(
        developerNames.map((assignee) => ({
          assignee,
          allocatedStoryPoints: 0,
          availableHours: 0,
        })),
      );
      setAvailableCapacity(0);
      setAllocatedCapacity(0);
      setRemainingCapacity(0);
      setIsRemainingNegative(false);
      setOverloadCount(0);
      setUnderloadCount(0);
      if (selectedDeveloper && !developerNames.includes(selectedDeveloper)) {
        setSelectedDeveloper(null);
        dispatch(setSelectedDeveloperName(null));
        sessionStorage.removeItem('developer');
        void handleTeam(null, dispatch);
      }
      return;
    }

    const currentData = resolveStandupScopeData({
      selectedValue,
      selectedSprint,
      selectedRelease,
      sprintList: getAllSprintList,
      releaseList: getAllReleaseList,
      jiraData,
    });
    const issues = jiraData?.jiraTableData?.issues;
    const isHoursBased = resolveStandupHoursBasedProject(currentData, {
      sprintList: getAllSprintList,
    });
    let assigneesList = Array.isArray(currentData?.assignees) ? currentData.assignees : [];
    if (assigneesList.length === 0) {
      assigneesList = buildStandupCapacityAssigneesFallback({
        issues: issues || [],
        userList: jiraData?.userList || [],
        existingAssignees: assigneesList,
        isHoursBased,
      });
    }
    assigneesList = enrichStandupCapacityAssigneesFromScope(assigneesList, currentData, jiraData);
    let capacityPlanAssignees = filterAssigneesForCapacityPlanView(assigneesList, isHoursBased);
    if (capacityPlanAssignees.length === 0 && Array.isArray(issues) && issues.length > 0) {
      capacityPlanAssignees = filterAssigneesForCapacityPlanView(
        enrichStandupCapacityAssigneesFromScope(
          buildStandupCapacityAssigneesFallback({
            issues,
            userList: jiraData?.userList || [],
            existingAssignees: assigneesList,
            isHoursBased,
          }),
          currentData,
          jiraData,
        ),
        isHoursBased,
      );
    }
    setIsHoursBasedProject(isHoursBased);
    sessionStorage.setItem('isHoursBasedProject', isHoursBased.toString());
    const issueEstimatedByAssignee = buildIssueEstimateTotalsByAssignee(issues || [], isHoursBased);

    const assigneeStoryPointList = capacityPlanAssignees.map((item) => {
      const allocatedValue = allocatedCapacityForAssignee(
        item,
        isHoursBased,
        issueEstimatedByAssignee,
      );
      return {
        assignee: item.assignee,
        allocatedStoryPoints: allocatedValue,
        availableHours: resolveAssigneeNetAvailableCapacity(item, isHoursBased),
      };
    });
      issueEstimatedByAssignee.forEach((estimated, assignee) => {
      if (!assigneeStoryPointList.some((x) => String(x.assignee || '').trim() === assignee)) {
        assigneeStoryPointList.push({
          assignee,
          allocatedStoryPoints: Number(estimated || 0),
          availableHours: 0,
        });
      }
    });
    const injectUnassignedForIssues =
      jiraIssuesHaveMissingAssignee(issues) &&
      !capacityPlanAssignees.some(
        (a) =>
          assigneeLabelIsUnassigned(a?.assignee) &&
          shouldShowUnassignedCapacityApiAssignee(a, isHoursBased),
      );

    const developerNames = collectStandupDeveloperNames(capacityPlanAssignees, jiraData?.userList, {
      injectUnassigned: injectUnassignedForIssues,
      includeProjectRoster: assigneesList.length === 0,
      isHoursBased,
    });
    setAssigneeStoryPointList(assigneeStoryPointList);
    setAssignees(developerNames);
    if (selectedDeveloper && !developerNames.includes(selectedDeveloper)) {
      setSelectedDeveloper(null);
      dispatch(setSelectedDeveloperName(null));
      sessionStorage.removeItem('developer');
      void handleTeam(null, dispatch);
    }
    const resolvedTotalAvailable = resolveTeamAvailableCapacityFallback(
      getAllSprintList,
      currentData,
      capacityPlanAssignees,
      isHoursBased,
    );

    const totalAllocatedFromPlan = sumAllocatedFromCapacityPlanAssignees(
      capacityPlanAssignees,
      isHoursBased,
      issueEstimatedByAssignee,
    );
    const totalAllocatedFromRoster = assigneeStoryPointList.reduce(
      (sum, item) => sum + Number(item.allocatedStoryPoints || 0),
      0,
    );
    const teamAllocatedTotal = isHoursBased ? totalAllocatedFromPlan : totalAllocatedFromRoster;

    let availableForSelectedDev = 0;
    let allocatedForSelectedDev = 0;
    let remainingForSelectedDev = 0;

    if (selectedDeveloper) {
      const selectedDevData = assigneeStoryPointList.find(
        (dev) => dev.assignee === selectedDeveloper,
      );
      if (selectedDevData) {
        availableForSelectedDev = selectedDevData.availableHours || 0;
        allocatedForSelectedDev = selectedDevData.allocatedStoryPoints || 0;
        remainingForSelectedDev = availableForSelectedDev - allocatedForSelectedDev;
      }
    }

    const commonAvailablePoints = selectedDeveloper
      ? availableForSelectedDev
      : resolvedTotalAvailable;
    const commonAllocatedPoints = selectedDeveloper
      ? allocatedForSelectedDev
      : teamAllocatedTotal;
    const commonRemainingPoints = selectedDeveloper
      ? remainingForSelectedDev
      : resolvedTotalAvailable - teamAllocatedTotal;
    setAvailableCapacity(Number(commonAvailablePoints.toFixed(2)));
    setAllocatedCapacity(Number(commonAllocatedPoints.toFixed(2)));
    setRemainingCapacity(Number(commonRemainingPoints.toFixed(2)));
    const isNegative = commonRemainingPoints < 0;
    setIsRemainingNegative(isNegative);

    let overload = 0;
    let underload = 0;

    capacityPlanAssignees.forEach((assignee) => {
      const dynamicAllocatedHours = allocatedCapacityForAssignee(
        assignee,
        isHoursBased,
        issueEstimatedByAssignee,
      );
      if (dynamicAllocatedHours <= 0) return;
      const capacity = resolveAssigneeNetAvailableCapacity(assignee, isHoursBased);
      if (dynamicAllocatedHours > capacity) {
        overload++;
      } else if (dynamicAllocatedHours < capacity) {
        underload++;
      }
    });
    setOverloadCount(overload);
    setUnderloadCount(underload);
  }, [
    jiraData,
    gitData,
    getStoryPoints,
    selectedDeveloper,
    selectedValue,
    selectedSprint,
    selectedRelease,
    isClickupList,
    getAllSprintList,
    getAllReleaseList,
    isAzure,
  ]);

  // Board selection state
  const [isBoardOpen, setIsBoardOpen] = useState(false);
  const [projectBoardCount, setProjectBoardCount] = useState({});
  const [subMenuBoards, setSubMenuBoards] = useState([]);
  const [subMenuPosition, setSubMenuPosition] = useState({ top: 0, left: 0 });
  const [currentProjectForBoard, setCurrentProjectForBoard] = useState(null);
  const fetchedProjectIdsRef = useRef(new Set());
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isBoardOpen && !event.target.closest('.board-submenu')) {
        setIsBoardOpen(false);
        setSubMenuBoards([]);
        setCurrentProjectForBoard(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isBoardOpen]);

  useEffect(() => {
    setSelectedSprintEndDate({
      id: currentSprint?._id,
      endDate: formatStandupDisplayDate(currentSprint?.endDate),
    });

    setSelectedSprintStartDate({
      id: currentSprint?._id,
      startDate: formatStandupDisplayDate(currentSprint?.startDate),
    });

    const releaseStartDate = currentRelease?.startDate ? new Date(currentRelease.startDate) : null;
    const releaseDate = currentRelease?.releaseDate ? new Date(currentRelease.releaseDate) : null;
    setSelectedReleaseDate({
      id: currentRelease?._id,
      startDate: releaseStartDate?.toLocaleDateString('en-IN') || 'NA',
      releaseDate: releaseDate?.toLocaleDateString('en-IN') || 'NA',
      overdue: currentRelease?.overdue,
    });

    let formattedCompleteDate = '';
    let referenceDate = new Date();
    if (currentSprint?.completeDate) {
      const completeDate = new Date(currentSprint?.completeDate);
      formattedCompleteDate = completeDate.toLocaleDateString('en-IN');
      referenceDate = completeDate;
    }
    setActualSprintEndDate({ id: currentSprint?._id, completeDate: formattedCompleteDate });

    if (currentSprint?.endDate) {
      const sprintEnd = new Date(currentSprint?.endDate);
      sprintEnd.setHours(23, 59, 59, 999);
      const compareStart = new Date(Math.min(referenceDate.getTime(), sprintEnd.getTime()));
      const compareEnd = new Date(Math.max(referenceDate.getTime(), sprintEnd.getTime()));
      const workingDays = getWorkingDaysBetweenDates(compareStart, compareEnd);
      setSprintDaysInfo({
        days: workingDays,
        status: referenceDate > sprintEnd ? 'overdue' : 'remaining',
      });
    }

    if (currentRelease?.releaseDate && currentRelease?.startDate) {
      const releaseEnd = new Date(currentRelease.releaseDate);
      releaseEnd.setHours(23, 59, 59, 999);

      const releaseStart = new Date(currentRelease.startDate);
      releaseStart.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let remainingWorkingDays;

      if (releaseStart > today) {
        remainingWorkingDays = getWorkingDaysBetweenDates(releaseStart, releaseEnd);
      } else {
        remainingWorkingDays = getWorkingDaysBetweenDates(today, releaseEnd);
      }

      setReleaseDaysInfo({
        remainingDays: remainingWorkingDays,
      });
    }
  }, [currentSprint, currentRelease]);

  useEffect(() => {
    if (isClickupList) {
      setIsUsingStoryPoints(false);
      setIsSprintGoalStoryPoints(false);
      return;
    }

    const sprintHasStoryPointMetrics = sprintdata.some(
      (item) =>
        item.committed > 0
        || item.completed > 0
        || item.plannedStoryPoints > 0,
    );
    const sprintHasHourMetrics = sprintdata.some(
      (item) =>
        item.committedHours > 0
        || item.completedHours > 0
        || item.plannedOriginalEstimateHrs > 0,
    );

    if (isHoursBasedProject && pointsSourceType !== 'effort') {
      setIsUsingStoryPoints(false);
      setIsSprintGoalStoryPoints(false);
      return;
    }

    setIsUsingStoryPoints(sprintHasStoryPointMetrics);
    if (sprintHasStoryPointMetrics) {
      setIsSprintGoalStoryPoints(true);
    } else if (sprintHasHourMetrics) {
      setIsSprintGoalStoryPoints(false);
    }
  }, [selectedDeveloper, sprintdata, isClickupList, isHoursBasedProject, pointsSourceType]);

  useEffect(() => {
    if (gridApiRef.current?.columnApi) {
      fullColumnDefs.forEach((col) => {
        const isVisible = visibleColumns.includes(col.field);
        gridApiRef.current.columnApi.setColumnVisible(col.field, isVisible);
      });
    }
  }, [fullColumnDefs, visibleColumns]);

  useEffect(() => {
    if (isClickupList) return;
    const estimateField = isHoursBasedProject && pointsSourceType !== 'effort'
      ? 'originalEstimate'
      : 'storyPoints';
    const required = fullColumnDefs.filter((col) => !col.optional).map((col) => col.field);
    setVisibleColumns((prev) => {
      const next = new Set([...required, ...prev]);
      next.add(estimateField);
      if (estimateField === 'originalEstimate') {
        next.delete('storyPoints');
      } else {
        next.delete('originalEstimate');
      }
      return fullColumnDefs
        .map((col) => col.field)
        .filter((field) => next.has(field));
    });
  }, [isHoursBasedProject, pointsSourceType, isClickupList, fullColumnDefs]);

  useEffect(() => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (showChurnDetails) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      const scrollY = document.body.style.top
        ? parseInt(document.body.style.top || '0', 10) * -1
        : 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      window.scrollTo(0, scrollY);
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAssigneeIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
    };
  }, [showChurnDetails]);

  const hasSessionData =
    Boolean(sessionStorage.getItem('projectId')) &&
    Boolean(sessionStorage.getItem('sprintId') || sessionStorage.getItem('releaseId'));
  const hasJiraData =
    jiraData?.selectedSprintId ||
    jiraData?.selectedReleaseId ||
    (jiraData?.projectList?.length > 0) ||
    jiraData?.Sprint ||
    jiraData?.Release;
  // Don't show spinner when we have cached data matching session (type-aware for Release vs Sprint).
  const sessionSprintId = sessionStorage.getItem('sprintId');
  const sessionReleaseId = sessionStorage.getItem('releaseId');
  const sessionTypeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
  const isReleaseSession =
    sessionTypeValue === APP_STRINGS.VALUE_RELEASE || (Boolean(sessionReleaseId) && !sessionSprintId);
  const hasDisplayableData = isReleaseSession
    ? Boolean(jiraData?.Release && jiraData?.selectedReleaseId)
    : Boolean(jiraData?.Sprint && jiraData?.selectedSprintId);
  const sessionMatchesContext = isReleaseSession
    ? String(sessionReleaseId || '') === String(jiraData?.selectedReleaseId || '')
    : String(sessionSprintId || '') === String(jiraData?.selectedSprintId || '');
  const useCachedDataWithoutSpinner = hasDisplayableData && sessionMatchesContext;
  const isFetchInProgress = loading || jiraData?.loadingEngMetrics;
  // Always overlay while a scope fetch runs (Release↔Sprint). Skip only on revisit with idle cache.
  const showSpinner =
    isFetchInProgress ||
    (!useCachedDataWithoutSpinner && hasSessionData && !hasJiraData);

  return (
    <div className="w-screen">
      <CommonLayout>
        {(isCollapsed) => (
          <>
            {showSpinner && (
              <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-light-100 bg-opacity-50 dark:bg-secondary-500 dark:bg-opacity-50 text-black dark:text-custom-gray z-50">
                <Spinner />
              </div>
            )}

            <div className="mt-20 ml-0 pb-10 relative transition-all duration-300">
              <div
                className="fixed top-14 z-20 left-[100px] right-0 pl-5 pr-0 flex flex-col dark:bg-[#151F2C] bg-[#F0F4F8] dark:shadow-none"
                aria-expanded={!isCollapsed}
              >
                <StandUpToolbarFiltersRow
                  getAllOrgsList={getAllOrgsList}
                  handleOrganizationChange={handleOrganizationChange}
                  selectedOrg={selectedOrg}
                  isOrganizationOpen={isOrganizationOpen}
                  setIsOrganizationOpen={setIsOrganizationOpen}
                  organizationRef={organizationRef}
                  getAllProjectList={getAllProjectList}
                  projectBoardCount={projectBoardCount}
                  handleProjectChange={handleProjectChange}
                  handleProjectHover={handleProjectHover}
                  handleProjectMouseLeave={handleProjectMouseLeave}
                  selectedProjectDisplayName={selectedProjectDisplayName}
                  isProjectOpen={isProjectOpen}
                  setIsProjectOpen={setIsProjectOpen}
                  projectRef={projectRef}
                  isBoardOpen={isBoardOpen}
                  subMenuBoards={subMenuBoards}
                  subMenuPosition={subMenuPosition}
                  currentProjectForBoard={currentProjectForBoard}
                  handleBoardChange={handleBoardChange}
                  setIsBoardOpen={setIsBoardOpen}
                  setSubMenuBoards={setSubMenuBoards}
                  setCurrentProjectForBoard={setCurrentProjectForBoard}
                  repoList={repoList}
                  handleRepoChange={handleRepoChange}
                  selectedRepos={selectedRepos}
                  isRepoOpen={isRepoOpen}
                  setIsRepoOpen={setIsRepoOpen}
                  repoRef={repoRef}
                  sprintLabel={sprintLabel}
                  releaseLabel={releaseLabel}
                  handleValueChange={handleValueChange}
                  selectedValue={selectedValue}
                  isValueOpen={isValueOpen}
                  setIsValueOpen={setIsValueOpen}
                  valueRef={valueRef}
                  getAllSprintList={standUpSprintDropdownList}
                  handleSprintChange={handleSprintChange}
                  selectedSprint={selectedSprint}
                  isSprintOpen={isSprintOpen}
                  setIsSprintOpen={setIsSprintOpen}
                  sprintRef={sprintRef}
                  getAllReleaseList={getAllReleaseList}
                  handleReleaseChange={handleReleaseChange}
                  selectedRelease={selectedRelease}
                  handleDateChange={handleDateChange}
                  theme={theme}
                  assigneeIsOpen={assigneeIsOpen}
                  setAssigneeIsOpen={setAssigneeIsOpen}
                  dropdownRef={dropdownRef}
                  selectedDeveloper={selectedDeveloper}
                  randomizeEnabled={randomizeEnabled}
                  toggleRandomize={toggleRandomize}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  displayedDevelopers={displayedDevelopers}
                  handleDeveloperSelect={handleDeveloperSelect}
                  handleTeamClick={handleTeamClick}
                  handleMultiProjectClick={handleMultiProjectClick}
                  isClickupList={isClickupList}
                  showBacklogOption={showBacklogOption}
                />
                {false && (
                <div className="flex space-x-2 flex-1 items-center pr-5 py-3">
                  <div className="w-1/7 mt-1 relative">
                    <DropdownButton
                      buttonLabel="Select Project"
                      options={getAllProjectList
                        ?.filter((project) => project.isSelected && project.hideStatus !== true)
                        .map((project) => ({
                          value: project._id,
                          label: project.name,
                          boardCount: projectBoardCount[project._id] || 0,
                          hasMultipleBoards: (projectBoardCount[project._id] || 0) > 1,
                        }))}
                      onSelect={handleProjectChange}
                      onOptionHover={handleProjectHover}
                      onOptionMouseLeave={handleProjectMouseLeave}
                      placeholder="Select Project"
                      selectedOption={selectedProjectDisplayName}
                      isOpen={isProjectOpen}
                      setIsOpen={setIsProjectOpen}
                      reference={projectRef}
                      type="project"
                      width="lg"
                    />
                  </div>

                  {/* Board Sub-menu Overlay */}
                  {isBoardOpen && subMenuBoards.length > 0 && (
                    <div
                      className="board-submenu fixed z-[9999] bg-white dark:bg-[#182433] rounded-lg shadow-lg border border-gray-200 dark:border-[#30445A] min-w-[200px]"
                      style={{
                        top: `${subMenuPosition.top}px`,
                        left: `${subMenuPosition.left}px`,
                      }}
                      onMouseEnter={() => {}}
                      onMouseLeave={() => {
                        setTimeout(() => {
                          const projectElement = document.querySelector(
                            `[data-project-id="${currentProjectForBoard}"]`,
                          );
                          if (!projectElement || !projectElement.matches(':hover')) {
                            setIsBoardOpen(false);
                            setSubMenuBoards([]);
                            setCurrentProjectForBoard(null);
                          }
                        }, 100);
                      }}
                    >
                      <div className="py-2">
                        {subMenuBoards.map((board, index) => (
                          <div
                            key={board.id || board._id || index}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-[#1E2B3A] transition-colors"
                            onClick={() => {
                              handleBoardChange(board.id || board._id, currentProjectForBoard);
                            }}
                          >
                            <span className="text-sm text-gray-700 dark:text-[#D9E4F1]">
                              {board.name || board.boardName} ({board.type || board.boardType})
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="mt-1 w-1/7 bg-[#182433] rounded ">
                    <RepoCheckboxDropdown
                      buttonLabel={APP_STRINGS.LABEL_SELECT_REPOSITORY}
                      options={
                        repoList?.map((project) => ({
                          label: project,
                          value: project,
                        })) || []
                      }
                      onSelect={handleRepoChange}
                      placeholder={APP_STRINGS.LABEL_SELECT_REPOSITORIES}
                      selectedRepos={selectedRepos}
                      isOpen={isRepoOpen}
                      setIsOpen={setIsRepoOpen}
                      reference={repoRef}
                      width="md"
                    />
                  </div>
                  <div className="mt-1">
                    <DropdownButton
                      options={[
                        { value: APP_STRINGS.VALUE_SPRINT, label: sprintLabel },
                        { value: APP_STRINGS.VALUE_DATE_RANGE, label: APP_STRINGS.VALUE_DATE_RANGE },
                        ...(isClickupList
                          ? []
                          : [{ value: APP_STRINGS.VALUE_RELEASE, label: releaseLabel }]),
                      ]}
                      onSelect={handleValueChange}
                      selectedOption={
                        selectedValue?.value === APP_STRINGS.VALUE_SPRINT
                          ? sprintLabel
                          : selectedValue?.value === APP_STRINGS.VALUE_RELEASE
                          ? releaseLabel
                          : selectedValue?.value
                      }
                      isOpen={isValueOpen}
                      setIsOpen={setIsValueOpen}
                      reference={valueRef}
                      width="sm"
                    />
                  </div>
                  <div>
                    {selectedValue.value === APP_STRINGS.VALUE_SPRINT && (
                      <div className="w-1/7 mt-1">
                        <DropdownButton
                          buttonLabel={`${APP_STRINGS.LABEL_SELECT_PREFIX}${sprintLabel}`}
                          options={standUpSprintDropdownList?.map((sprint) => ({
                            value: sprint?._id,
                            label: sprint?.name,
                            state: sprint?.state,
                            startDate: sprint?.startDate,
                            endDate: sprint?.endDate,
                            completeDate: sprint?.completeDate,
                          }))}
                          onSelect={handleSprintChange}
                          placeholder={APP_STRINGS.SELECT_AN_OPTION}
                          selectedOption={selectedSprint?.name}
                          isOpen={isSprintOpen}
                          setIsOpen={setIsSprintOpen}
                          reference={sprintRef}
                          type={APP_STRINGS.API_SPRINT}
                          includeFutureSprints
                          width="lg"
                        />
                      </div>
                    )}
                    {!isClickupList && selectedValue.value === APP_STRINGS.VALUE_RELEASE && (
                      <div className="w-1/7 mt-1">
                        <DropdownButton
                          buttonLabel={`${APP_STRINGS.LABEL_SELECT_PREFIX}${releaseLabel}`}
                          options={getAllReleaseList.map((sprint) => ({
                            value: sprint?._id,
                            label: sprint?.releaseName,
                            status: sprint?.status,
                          }))}
                          onSelect={handleReleaseChange}
                          placeholder={APP_STRINGS.LABEL_SELECT_RELEASE}
                          selectedOption={selectedRelease.releaseName}
                          isOpen={isSprintOpen}
                          setIsOpen={setIsSprintOpen}
                          reference={sprintRef}
                          type={APP_STRINGS.API_RELEASE}
                          width="lg"
                        />
                      </div>
                    )}
                    {selectedValue.value === APP_STRINGS.VALUE_DATE_RANGE && (
                      <div className="mt-1">
                        <DateRangePicker onChange={handleDateChange} />
                      </div>
                    )}
                  </div>

                  <div className="flex-1 flex justify-end mt-1 ml-auto -mr-10">
                    <div
                      className={`flex items-center dark:bg-[#000000] bg-[#FCFBFB] rounded-full px-2 py-1 ${
                        theme === 'light'
                          ? `${
                              assigneeIsOpen
                                ? 'border border-[#7691CA] shadow-[0_0_4px_rgba(48,85,169,0.4)]'
                                : 'border border-[#A6C3DC] hover:border-[#A6C3DC]'
                            }`
                          : 'border border-[#066FD1]'
                      } transition-all`}
                      ref={dropdownRef}
                    >
                      <div className="relative">
                        <button
                          onClick={() => {
                            const newState = !assigneeIsOpen;
                            setAssigneeIsOpen(newState);
                            if (newState) {
                              setSearchTerm('');
                            }
                          }}
                          className={`flex items-center justify-between w-[180px] px-2 py-1 ${
                            theme === 'light'
                              ? `${
                                  selectedDeveloper
                                    ? 'dark:bg-[#066FD1] bg-[#24527A] text-[#24527A]'
                                    : 'bg-transparent text-[#24527A] hover:bg-[#F7F9FF]'
                                }`
                              : `text-[#D9E4F1] ${
                                  selectedDeveloper ? 'bg-[#066FD1]' : 'bg-[#000000]'
                                }`
                          } rounded-full transition-all`}
                        >
                          <span
                            className={`truncate text-sm ${
                              theme === 'light' && selectedDeveloper ? 'text-[#FFFFFF]' : ''
                            }`}
                          >
                            {selectedDeveloper ? selectedDeveloper : 'Select Developer'}
                          </span>
                          <svg
                            className="w-2.5 h-2.5 ml-2"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6"
                            style={{
                              color: theme === 'light' ? 'rgba(63, 63, 63, 0.6)' : 'currentColor',
                            }}
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="m1 1 4 4 4-4"
                            />
                          </svg>
                        </button>

                        {assigneeIsOpen && (
                          <div
                            className={`absolute left-0 z-10 mt-2 w-full rounded-lg overflow-hidden max-h-60 shadow-[0_4px_16px_0_rgba(0,0,0,0.8)] ${
                              theme === 'light' ? 'bg-[#FFFFFF]' : 'bg-[#182433]'
                            }`}
                          >
                            <div
                              className={`border-b ${
                                theme === 'light'
                                  ? 'bg-[#FFFFFF] border-[#E5E5E5]'
                                  : 'bg-[#182433] border-[#1F2F41]'
                              }`}
                            >
                              {/* Randomize Toggle */}
                              <div
                                className={`flex items-center justify-between p-1 ${
                                  theme === 'light' ? 'bg-[#FFFFFF]' : 'bg-[#182433]'
                                }`}
                              >
                                <button
                                  onClick={toggleRandomize}
                                  className={`relative inline-flex items-center h-5 rounded-full w-9 focus:outline-none border ${
                                    theme === 'light' ? 'border-[#bfbfbf]' : 'border-[#000000]'
                                  }`}
                                >
                                  <span
                                    className={`${
                                      randomizeEnabled
                                        ? 'bg-[#24527A]'
                                        : theme === 'light'
                                        ? 'bg-[#bfbfbf]'
                                        : 'bg-[#2D3137]'
                                    } absolute h-5 w-9 rounded-full transition-colors`}
                                  ></span>
                                  <span
                                    className={`${
                                      randomizeEnabled ? 'translate-x-5' : 'translate-x-1'
                                    } inline-block h-3 w-3 transform rounded-full bg-white transition-transform`}
                                  ></span>
                                </button>
                                <span
                                  className={`text-sm ${
                                    theme === 'light' ? 'text-[#24527A]' : 'text-[#D9E4F1]'
                                  }`}
                                >
                                  Randomize
                                </span>
                              </div>
                              <div
                                className={`relative ${
                                  theme === 'light' ? 'bg-[#FFFFFF]' : 'bg-[#182433]'
                                }`}
                              >
                                <div className="absolute top-0 bottom-0 left-0 flex items-center justify-center w-6 pointer-events-none">
                                  <Search
                                    size={16}
                                    className={
                                      theme === 'light' ? 'text-[#24527A]' : 'text-[#CED5E3]'
                                    }
                                  />
                                </div>
                                <input
                                  type="text"
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  placeholder="Search"
                                  className={`w-full text-sm pr-3 focus:outline-none border-none ${
                                    theme === 'light' ? 'text-[#24527A]' : 'text-[#D9E4F199]'
                                  }`}
                                  style={{
                                    textIndent: '1.75rem',
                                    backgroundColor: theme === 'light' ? '#FFFFFF' : '#1e293b',
                                  }}
                                />
                              </div>
                            </div>

                            <div className="max-h-40 overflow-y-auto">
                              {displayedDevelopers.length > 0 ? (
                                displayedDevelopers?.map((developer, index) => {
                                  const isSelected = selectedDeveloper === developer;
                                  return (
                                  <div
                                    key={index}
                                    role="option"
                                    aria-selected={isSelected}
                                    className={`px-4 py-1 cursor-pointer transition-all ${
                                      isSelected
                                        ? 'bg-[#066FD1] text-[#FFFFFF]'
                                        : theme === 'light'
                                        ? 'text-[#24527A] hover:bg-[#F7F9FF]'
                                        : 'text-[#D9E4F1] hover:bg-[#1E2B3A]'
                                    }`}
                                    onClick={() => handleDeveloperSelect(developer)}
                                  >
                                    {developer}
                                  </div>
                                  );
                                })
                              ) : (
                                <div
                                  className={`px-4 py-2 text-sm text-center ${
                                    theme === 'light' ? 'text-[#24527A]' : 'text-white'
                                  }`}
                                >
                                  No developer found
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <button
                        onClick={handleTeamClick}
                        className={`ml-2 ${
                          theme === 'light'
                            ? `${
                                selectedDeveloper
                                  ? 'bg-transparent text-[#24527A] hover:bg-[#F7F9FF]'
                                  : 'dark:bg-[#066FD1] bg-[#24527A] text-[#FFFFFF]'
                              }`
                            : `${
                                selectedDeveloper ? 'bg-[#000000]' : 'bg-[#066FD1]'
                              } text-[#D9E4F1]`
                        } hover:bg-[#2563eb] text-sm px-2 py-1 rounded-full transition-all`}
                      >
                        Team
                      </button>
                    </div>
                  </div>
                </div>
                )}

                {!isBacklogMode && (
                <div
                  className="flex items-center mt-1 dark:bg-[#293345] bg-[#D9EAF9] w-full"
                  aria-expanded={!isCollapsed}
                >
                  {selectedValue.value === APP_STRINGS.VALUE_SPRINT && selectedSprint.name && (
                    <div className="flex items-center space-x-4 text-[15px] h-[34px] p-2 pl-8 flex-1 min-w-0">
                      <div className="dark:text-[#48A7FF] text-[#066FD1]">
                        {sprintLabel} Start & End Date:{' '}
                        <span>{selectedSprintStartDate.startDate}</span> -{' '}
                        <span>{selectedSprintEndDate.endDate}</span>
                      </div>
                      <div className="dark:text-[#F59F12] text-[#F59F12]">
                        Actual {sprintLabel} End Date:{' '}
                        <span className="dark:text-[#F59F12] text-[#F59F12]">
                          {actualSprintEndDate?.completeDate
                            ? actualSprintEndDate.completeDate
                            : 'NA'}
                        </span>
                      </div>
                      {sprintDaysInfo &&
                        selectedSprintEndDate.endDate !== actualSprintEndDate?.completeDate && (
                          <div
                            className={
                              sprintDaysInfo.status === 'overdue'
                                ? 'text-[#FF0000]'
                                : theme === 'light' ? 'text-green-600' : 'text-[#64D518]'
                            }
                          >
                            {sprintDaysInfo.status === 'overdue' ? (
                              <>
                                {sprintDaysInfo.days} day{sprintDaysInfo.days > 1 ? 's' : ''}{' '}
                                overdue
                              </>
                            ) : (
                              <>
                                {sprintDaysInfo.days} day{sprintDaysInfo.days > 1 ? 's' : ''}{' '}
                                remaining
                              </>
                            )}
                          </div>
                        )}
                    </div>
                  )}
                  {selectedValue.value === APP_STRINGS.VALUE_RELEASE &&
                    !isClickupList &&
                    selectedRelease?.releaseName && (
                    <div className="flex items-center space-x-4 text-[15px] h-[34px] p-2 flex-1 min-w-0">
                      <div className="text-[#066FD1] dark:text-[#48A7FF] flex items-center space-x-2">
                        <span>
                          {releaseLabel} Start & End Date:{' '}
                          {selectedReleaseDate?.startDate === 'NA' &&
                          selectedReleaseDate?.releaseDate === 'NA' ? (
                            <span>NA</span>
                          ) : (
                            <>
                              <span>{selectedReleaseDate?.startDate ?? 'NA'}</span> -{' '}
                              <span
                                className={
                                  currentRelease?.isFallbackUsed === true
                                    ? 'text-red-500 font-medium'
                                    : ''
                                }
                              >
                                {selectedReleaseDate?.releaseDate ?? 'NA'}
                              </span>
                            </>
                          )}
                        </span>
                        {selectedReleaseDate?.overdue && (
                          <div className="flex items-center space-x-2">
                            <span className="bg-[#D92D20] text-white text-xs font-medium px-2 py-1 rounded-full flex items-center space-x-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l5.514 9.799c.75 1.333-.213 3.002-1.742 3.002H4.485c-1.53 0-2.492-1.67-1.742-3.002l5.514-9.799zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span>Overdue</span>
                            </span>
                          </div>
                        )}
                        {selectedReleaseDate?.startDate !== 'NA' &&
                          selectedReleaseDate?.releaseDate !== 'NA' &&
                          !selectedReleaseDate?.overdue &&
                          selectedReleaseDate?.releaseDate &&
                          currentRelease?.status === 'Unreleased' && (
                            <span className={`${theme === 'light' ? 'text-green-500' : 'text-[#64D518]'} text-sm font-medium`}>
                              {releaseDaysInfo?.remainingDays} day
                              {releaseDaysInfo.remainingDays > 1 ? 's' : ''} remaining
                            </span>
                          )}
                        {currentRelease?.isFallbackUsed && (
                          <div className="flex items-center space-x-2">
                            <span className="bg-yellow-500 text-white text-xs font-medium px-2 py-1 rounded-sm flex items-center space-x-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l5.514 9.799c.75 1.333-.213 3.002-1.742 3.002H4.485c-1.53 0-2.492-1.67-1.742-3.002l5.514-9.799zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span>
                                {' '}
                                Using today’s date as end date and update it for accurate result.
                              </span>
                            </span>
                          </div>
                        )}
                        {selectedReleaseDate?.startDate === 'NA' &&
                          selectedReleaseDate?.releaseDate !== 'NA' && (
                            <div className="flex items-center space-x-2">
                              <span className="bg-[#D92D20] text-white text-xs font-medium px-2 py-1 rounded-sm flex items-center space-x-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 text-white"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l5.514 9.799c.75 1.333-.213 3.002-1.742 3.002H4.485c-1.53 0-2.492-1.67-1.742-3.002l5.514-9.799zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span>
                                  {' '}
                                  Release start date is missing. set it to get full metrics.
                                </span>
                              </span>
                            </div>
                          )}
                        {selectedReleaseDate?.startDate === 'NA' &&
                          selectedReleaseDate?.releaseDate === 'NA' && (
                            <div className="flex items-center space-x-2">
                              <span className="bg-[#D92D20] text-white text-xs font-medium px-2 py-1 rounded-sm flex items-center space-x-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 text-white"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l5.514 9.799c.75 1.333-.213 3.002-1.742 3.002H4.485c-1.53 0-2.492-1.67-1.742-3.002l5.514-9.799zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span>
                                  {' '}
                                  Release start & end dates are missing. update them to get full
                                  metrics.
                                </span>
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </div>
                )}
              </div>
            </div>
            {!isCreatedDateFilter && !isBacklogMode && (
            <div
              className={`mt-5 ${
                (selectedValue.value === APP_STRINGS.VALUE_SPRINT && selectedSprint.name) ||
                (!isClickupList &&
                  selectedValue.value === APP_STRINGS.VALUE_RELEASE &&
                  selectedRelease?.releaseName &&
                  selectedReleaseDate?.releaseDate)
                  ? 'pt-10'
                  : 'pt-4'
              } flex flex-wrap gap-5 justify-center lg:justify-between`}
            >
              {/* {/ {/ Sprint Churn (Wider)  /} /} */}
              <StandUpChurnSection
                getChurnData={getChurnData}
                churnTableData={churnTableData}
                selectedValue={selectedValue}
                selectedOption={selectedOption}
                selectedSprint={selectedSprint}
                selectedRelease={selectedRelease}
                releaseLabel={releaseLabel}
                sprintLabel={sprintLabel}
                excludeBugsInChurn={excludeBugsInChurn}
                handleExcludeBugsInChurnToggle={handleExcludeBugsInChurnToggle}
                issueTypes={issueTypes}
                createShortName={createShortName}
                setSelectedOption={setSelectedOption}
                storyChurnData={storyChurnData}
                handleViewChurnDetails={handleViewChurnDetails}
                heavyChartsReady={heavyChartsReady}
                chartSuspenseFallback={chartSuspenseFallback}
                chartLineData={chartLineData}
                theme={theme}
                ChurnStoryLineChart={ChurnStoryLineChart}
                ChurnStoryStackedBarChart={ChurnStoryStackedBarChart}
              />
              <Modal
                isOpen={showChurnDetails}
                onClose={handleCloseDetails}
                title={`${
                  selectedOption === 'All'
                    ? selectedValue?.value === APP_STRINGS.VALUE_RELEASE
                      ? releaseLabel
                      : sprintLabel
                    : selectedOption
                } Churn`}
                size="medium"
                content={
                  <div className="ag-theme-alpine-dark" style={{ height: '295px', width: '100%' }}>
                    {heavyChartsReady ? (
                      <Suspense fallback={chartSuspenseFallback}>
                        <AGrid
                          rowData={transformedRowData}
                          columnDefs={StoryChurnColumns}
                          frameworkComponents={{ issueTypeRenderer: IssueTypeDropdown }}
                          context={{ onCellValueChanged: handleIssueTypeChange }}
                          height="290px"
                          defaultColDef={{ flex: 1, resizable: true }}
                          theme={theme}
                          disableFirstColumnSearch={true}
                        />
                      </Suspense>
                    ) : (
                      chartSuspenseFallback
                    )}
                  </div>
                }
              />

              {/* Capacity widget */}
              <StandUpCapacitySection
                theme={theme}
                selectedDeveloper={selectedDeveloper}
                handleViewCapacityDetails={handleViewCapacityDetails}
                capacityGaugeGeom={capacityGaugeGeom}
                capacityGaugeUtilization={capacityGaugeUtilization}
                availableCapacity={availableCapacity}
                pointsSourceType={pointsSourceType}
                isHoursBasedProject={isHoursBasedProject}
                allocatedCapacity={allocatedCapacity}
                isRemainingNegative={isRemainingNegative}
                capacityBarSegments={capacityBarSegments}
                overloadCount={overloadCount}
                underloadCount={underloadCount}
                remainingCapacity={remainingCapacity}
              />

              {/* Jira Graph */}
              <div className="p-[10px] bg-[#FFFFFF] basis-[280px] flex-grow mr-2 dark:bg-[#182433] dark:text-[#C8C8C8] text-[#24527A] rounded-[10px] shadow-[0_1px_20px_rgba(0,0,0,0.1)] dark:shadow-md border border-[#D1E2F0] dark:border-[#25384F] min-w-[300px] min-h-[260px] max-h-[260px] flex flex-col overflow-hidden">
                <div className="relative mb-4 flex-shrink-0">
                  <div className="flex items-center gap-1 self-start mb-4">
                    <h3 className="text-lg text-[#0A2342] dark:text-white mb-0">
                      {getPlatformName(isGitLab, isAzure, isClickupList, isGithubIssues)}
                    </h3>
                    <div className="relative group">
                      <TooltipIcon
                        title={
                          isClickupList
                            ? 'StandupClickUpStatus'
                            : isGithubIssues
                              ? 'StandupGitHubStatus'
                              : 'StandupJiraStatus'
                        }
                        tooltip={
                          isClickupList
                            ? 'ClickUp tasks grouped by status for the selected milestone or sprint.'
                            : isGithubIssues
                              ? 'GitHub issues grouped by workflow status for the </br> selected iteration / milestone.'
                              : 'Jira work items grouped by workflow status for the </br> selected SPRINT / RELEASE'
                        }
                        theme={theme}
                        placement="top-start"
                      />
                    </div>
                  </div>
                  <div className="absolute top-0 right-0">
                    <div className="inline-flex items-center bg-transparent dark:bg-[#242B34] rounded-full p-0.5 border border-[#E5E5E5] dark:border-[#101010]">
                      <button
                        onClick={() => setSortOrder('default')}
                        className={`px-4 py-1 text-xs font-medium rounded-full transition-colors ${
                          sortOrder === 'default'
                            ? 'dark:bg-[#066FD1] bg-[#24527A] text-white'
                            : 'text-[#24527A] dark:text-gray-300'
                        }`}
                      >
                        Default
                      </button>
                      <button
                        onClick={() => setSortOrder('asc')}
                        className={`px-4 py-1 text-xs font-medium rounded-full transition-colors ${
                          sortOrder === 'asc'
                            ? 'dark:bg-[#066FD1] bg-[#24527A] text-white'
                            : 'text-[#24527A] dark:text-gray-300'
                        }`}
                      >
                        ASC
                      </button>
                      <button
                        onClick={() => setSortOrder('desc')}
                        className={`px-4 py-1 text-xs font-medium rounded-full transition-colors ${
                          sortOrder === 'desc'
                            ? 'dark:bg-[#066FD1] bg-[#24527A] text-white'
                            : 'text-[#24527A] dark:text-gray-300'
                        }`}
                      >
                        DSC
                      </button>
                    </div>
                  </div>
                </div>
                {(sortOrder === 'default' || sortOrder === 'desc' || sortOrder === 'asc') && (
                  <div
                    className={`relative flex-1 min-h-0 overflow-y-auto overflow-x-auto scrollbar-track-transparent ${
                      theme === 'light' ? 'scrollbar-super-thin-lightMode' : 'scrollbar-super-thin'
                    }`}
                  >
                    <ResponsiveContainer width="100%" height={sortedBarChartData.length * 25 + 40}>
                      <BarChart
                        data={sortedBarChartData.map((item) => ({
                          ...item,
                          color: getStatusColor(item.status, statusColorMap).hex,
                        }))}
                        layout="vertical"
                        barCategoryGap="100%"
                        margin={{
                          top: 0,
                          right: 8,
                          left: statusBarLeftMargin,
                          bottom: 0,
                        }}
                        maxBarSize={200}
                      >
                        <XAxis
                          type="number"
                          stroke={theme === 'light' ? '#24527A' : '#e1def5e6'}
                          axisLine={false}
                          tickLine={false}
                          fontSize={10}
                        />
                        <YAxis
                          dataKey="status"
                          type="category"
                          stroke={theme === 'light' ? '#24527A' : '#e1def5e6'}
                          axisLine={false}
                          tickLine={false}
                          fontSize={10}
                          interval={0}
                          tick={({ x, y, payload }) => {
                            const text = payload.value;
                            const maxLength = 15;
                            const displayText =
                              text.length > maxLength ? text.substring(0, maxLength) + '...' : text;

                            return (
                              <g>
                                <title>{text}</title>
                                <text
                                  x={x}
                                  y={y}
                                  textAnchor="end"
                                  fill={theme === 'light' ? '#24527A' : '#C8C8C8'}
                                  fontSize={11}
                                  dy={4}
                                >
                                  {displayText}
                                </text>
                              </g>
                            );
                          }}
                        />
                        <Tooltip content={<JiraGraphTooltip />} cursor={{ fill: 'transparent' }} />
                        <Bar
                          dataKey="count"
                          radius={[10, 10, 10, 10]}
                          barSize={5}
                          background={{
                            fill: theme === 'light' ? '#DBE1EA' : '#25384F',
                            radius: [10, 10, 10, 10],
                          }}
                        >
                          {sortedBarChartData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={getStatusColor(entry.status, statusColorMap).hex}
                            />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>
            </div>
            )}
            {!isCreatedDateFilter && !isBacklogMode && (
            <div className="pt-5 flex flex-wrap basis-[300px] gap-5 justify-center lg:justify-between w-full min-w-0">
              {/* Burndown Chart */}
              <StandUpBurndownSection
                isReleaseSelected={isReleaseSelected}
                isKanbanRelease={isKanbanRelease}
                dailyWiseStatusCount={dailyWiseStatusCount}
                DailyWiseStatusCountChart={DailyWiseStatusCountChart}
                selectedDeveloper={selectedDeveloper}
                selectedValue={selectedValue}
                burndownStatus={burndownStatus}
                isStoryPoints={isStoryPoints}
                setIsStoryPoints={setIsStoryPoints}
                lockToHours={lockToHours}
                lockToPoints={lockToPoints}
                pointsSourceType={pointsSourceType}
                newBurndownData={newBurndownData}
                chartSuspenseFallback={chartSuspenseFallback}
                burndownChartData={burndownChartData}
                theme={theme}
                isHoursBasedProject={isHoursBasedProject}
                selectedSprint={selectedSprint}
                jiraData={jiraData}
                todaysVelocity={todaysVelocity}
                yesterdayVelocity={yesterdayVelocity}
                heavyChartsReady={heavyChartsReady}
                LazyReleaseBurndownStackedBar={ReleaseBurndownStackedBar}
                BurndownSprintLineChart={BurndownSprintLineChart}
                isGithubIssues={isGithubIssues}
                isClickupList={isClickupList}
              />
              {false && (
              <div
                className={`p-0 bg-[#FFFFFF] dark:bg-[#182433] dark:text-[#C8C8C8] text-black rounded-[10px] shadow-[0_1px_20px_0_rgba(0,0,0,0.1)] dark:shadow-md border ${isReleaseSelected ? 'border-[#D1E2F0]' : 'border-[#E5E5E5]'} dark:border-[#25384F] ${
                  isReleaseSelected ? 'h-[352px]' : 'h-[297px]'
                } flex flex-col overflow-hidden min-w-0 max-w-full ${
                  isReleaseSelected
                    ? 'w-[calc(100%-1.75rem)] min-w-0 max-w-[calc(100%-1.75rem)] ml-5 mr-2'
                    : 'ml-5 basis-[300px] flex-grow min-w-[340px]'
                }`}
              >
                <div className={`flex items-center gap-2 pb-2.5 flex-shrink-0 ${isReleaseSelected ? 'pt-3 pl-[30px] pr-2' : 'px-2 pt-1.5'}`}>
                  <div className="flex items-center gap-1 w-1/3 min-w-0">
                    <h3 className="text-lg text-[#202020] dark:text-white shrink-0">Burndown</h3>
                    <div className="relative group shrink-0">
                      <TooltipIcon
                        title="StandupBurndown"
                        tooltip="Tracks remaining work over time vs. the ideal burndown line <br /> for the selected SPRINT / RELEASE"
                        theme={theme}
                        placement="top-start"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-center w-1/3">
                    {!selectedDeveloper && selectedValue?.value === APP_STRINGS.VALUE_SPRINT && (
                      <>
                        {burndownStatus === 'greatGoing' && (
                          <div className="flex items-center gap-1.5 text-green-500">
                            <ThumbsUp className="w-4 h-4" />
                            <span className="text-sm font-medium">Great Going!</span>
                          </div>
                        )}
                        {burndownStatus === 'moveFaster' && (
                          <div className="flex items-center gap-1.5 text-red-500">
                            <AlertTriangle className="w-4 h-4" />
                            <span className="text-sm font-medium">Move Faster</span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="flex items-center justify-end w-1/3 relative">
                    {selectedValue?.value === APP_STRINGS.VALUE_SPRINT && (
                      <div className="inline-flex items-center bg-transparent dark:bg-[#242B34] rounded-full p-0.5 border border-[#E5E5E5] dark:border-[#101010]">
                        <button
                          className={`px-2 py-1 rounded-full text-xs font-medium transition-colors ${
                            isStoryPoints
                              ? 'dark:bg-[#066FD1] bg-[#24527A] text-white'
                              : 'text-[#24527A] dark:text-gray-500'
                          }`}
                          onClick={() => setIsStoryPoints(true)}
                          disabled={lockToHours}
                        >
                          {standupPointsModeTabLabel({
                            pointsSourceType,
                            isGithubIssues,
                            modeSelected: isStoryPoints,
                          })}
                        </button>
                        <button
                          className={`px-2 py-1 rounded-full text-xs font-medium transition-colors ${
                            !isStoryPoints
                              ? 'dark:bg-[#066FD1] bg-[#24527A] text-white'
                              : 'text-[#24527A] dark:text-gray-500'
                          }`}
                          onClick={() => setIsStoryPoints(false)}
                          disabled={lockToPoints}
                        >
                          Hrs
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Conditional Rendering: Stacked Bar for Release, Line Chart for Sprint */}
                {!isClickupList &&
                selectedValue?.value === APP_STRINGS.VALUE_RELEASE &&
                 newBurndownData?.sprintBreakdown && 
                 Array.isArray(newBurndownData.sprintBreakdown) &&
                 newBurndownData.sprintBreakdown.length > 0 ? (
                  // Release Burndown - Stacked Bar Chart
                  <div className="flex-1 min-h-0 min-w-0 overflow-hidden">
                    <Suspense fallback={chartSuspenseFallback}>
                      <ReleaseBurndownStackedBar
                        data={burndownChartData}
                        theme={theme}
                        isHoursBasedProject={isHoursBasedProject}
                        isGithubIssues={isGithubIssues}
                      />
                    </Suspense>
                  </div>
                ) : selectedValue?.value === APP_STRINGS.VALUE_SPRINT ? (
                  // Sprint Burndown - Line Chart (existing implementation)
                  <>
                    {/* Key Metrics Bar */}
                    {!selectedDeveloper &&
                      selectedValue &&
                      selectedValue.value &&
                      selectedSprint &&
                      selectedSprint.name && (
                        <div className="px-2 py-1 mb-0.5 flex-shrink-0 burndown-metrics-container">
                          <div className="bg-[#F5F5F5] dark:bg-[#1E2A3A] border border-[#E5E5E5] dark:border-[#3A4A5F] rounded-lg px-1.5 py-1 shadow-sm">
                            <div className="flex items-center gap-0 flex-nowrap burndown-metrics-wrapper">
                              <div className="flex items-center gap-0.5 min-w-0 flex-shrink burndown-metric-item">
                                <span className="text-[11px] text-[#202020] dark:text-white whitespace-nowrap">
                                  Today&apos;s
                                </span>
                                {Math.round(jiraData?.burndownVelocity?.today ?? 0) > 999 ? (
                                  <CommonTooltip
                                    content={Math.round(
                                      jiraData?.burndownVelocity?.today ?? 0,
                                    ).toLocaleString()}
                                    position="top"
                                  >
                                    <span
                                      className="text-[11px] font-semibold ml-1"
                                      style={{ color: '#457EFF' }}
                                    >
                                      {
                                        formatNumberWithSuffix(
                                          Math.round(jiraData?.burndownVelocity?.today ?? 0),
                                        ).formatted
                                      }
                                    </span>
                                  </CommonTooltip>
                                ) : (
                                  <span
                                    className="text-[11px] font-semibold ml-1"
                                    style={{ color: '#457EFF' }}
                                  >
                                    {
                                      formatNumberWithSuffix(
                                        Math.round(jiraData?.burndownVelocity?.today ?? 0),
                                      ).formatted
                                    }
                                  </span>
                                )}

                            {todaysVelocity > yesterdayVelocity ? (
                              <ArrowUp
                                className="w-3 h-3 text-green-500"
                                style={{ transform: 'rotate(45deg)' }}
                              />
                            ) : todaysVelocity < yesterdayVelocity ? (
                              <ArrowDown
                                className="w-3 h-3 text-red-500"
                                style={{ transform: 'rotate(-45deg)' }}
                              />
                            ) : null}
                          </div>

                              <div className="flex items-center gap-0.2 min-w-0 flex-shrink burndown-metric-item ml-0.5">
                                <span className="text-[11px] text-[#202020] dark:text-white whitespace-nowrap">
                                  Yesterday&apos;s
                                </span>
                                {Math.round(jiraData?.burndownVelocity?.yesterday ?? 0) > 999 ? (
                                  <CommonTooltip
                                    content={Math.round(
                                      jiraData?.burndownVelocity?.yesterday ?? 0,
                                    ).toLocaleString()}
                                    position="top"
                                  >
                                    <span
                                      className="text-[11px] font-semibold ml-1"
                                      style={{ color: '#457EFF' }}
                                    >
                                      {
                                        formatNumberWithSuffix(
                                          Math.round(jiraData?.burndownVelocity?.yesterday ?? 0),
                                        ).formatted
                                      }
                                    </span>
                                  </CommonTooltip>
                                ) : (
                                  <span
                                    className="text-[11px] font-semibold ml-1"
                                    style={{ color: '#457EFF' }}
                                  >
                                    {
                                      formatNumberWithSuffix(
                                        Math.round(jiraData?.burndownVelocity?.yesterday ?? 0),
                                      ).formatted
                                    }
                                  </span>
                                )}
                              </div>

                              <div
                                className="px-1.5 py-1 bg-[#326AEB1A] dark:bg-[#326AEB1A] rounded-md text-[11px] font-medium min-w-fit flex-shrink text-center burndown-metric-item flex items-center justify-center ml-5"
                                style={{ color: '#457EFF' }}
                              >
                                <span className="whitespace-nowrap">
                                  Target:{' '}
                                  {(() => {
                                    const targetVelocity = truncateToOneDecimal(jiraData?.burndownVelocity?.targetVelocity ?? 0);
                                    return targetVelocity > 999 ? (
                                      <CommonTooltip
                                        content={formatMetricOneDecimal(targetVelocity)}
                                        position="top"
                                      >
                                        <span>
                                          {formatNumberWithSuffix(targetVelocity, 1).formatted}
                                        </span>
                                      </CommonTooltip>
                                    ) : (
                                      <span>{formatMetricOneDecimal(targetVelocity)}</span>
                                    );
                                  })()}
                                </span>
                              </div>

                              <div
                                className="px-1.5 py-1 bg-[#326AEB1A] dark:bg-[#326AEB1A] rounded-md text-[11px] font-medium min-w-fit flex-shrink text-center burndown-metric-item flex items-center justify-center ml-0.5"
                                style={{ color: '#457EFF' }}
                              >
                                <span className="whitespace-nowrap">
                                  Completed:{' '}
                                  {(() => {
                                    const completedVelocity = truncateToOneDecimal(jiraData?.burndownVelocity?.completedTillDate ?? 0);
                                    return completedVelocity > 999 ? (
                                      <CommonTooltip
                                        content={formatMetricOneDecimal(completedVelocity)}
                                        position="top"
                                      >
                                        <span>
                                          {formatNumberWithSuffix(completedVelocity, 1).formatted}
                                        </span>
                                      </CommonTooltip>
                                    ) : (
                                      <span>{formatMetricOneDecimal(completedVelocity)}</span>
                                    );
                                  })()}
                                </span>
                              </div>

                              <div
                                className="px-0.5 py-1 bg-[#326AEB1A] dark:bg-[#326AEB1A] rounded-md text-[11px] font-medium min-w-fit flex-shrink-0 text-center burndown-metric-item flex items-center justify-center -ml-0.5"
                                style={{ color: '#457EFF' }}
                              >
                                <span className="whitespace-nowrap">
                                  {selectedValue?.value === APP_STRINGS.VALUE_SPRINT
                                    ? '5 Sprints Avg:'
                                    : '5 Releases Avg:'}{' '}
                                  {Math.round(jiraData?.burndownVelocity?.averageVelocity ?? 0) > 999 ? (
                                    <CommonTooltip
                                      content={Math.round(
                                        jiraData?.burndownVelocity?.averageVelocity ?? 0,
                                      ).toLocaleString()}
                                      position="top"
                                    >
                                      <span>
                                        {
                                          formatNumberWithSuffix(
                                            Math.round(jiraData?.burndownVelocity?.averageVelocity ?? 0),
                                          ).formatted
                                        }
                                      </span>
                                    </CommonTooltip>
                                  ) : (
                                    <span>
                                      {
                                        formatNumberWithSuffix(
                                          Math.round(jiraData?.burndownVelocity?.averageVelocity ?? 0),
                                        ).formatted
                                      }
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {/* Scrollable Chart */}
                    <div
                      className={`w-full flex-1 min-h-0 overflow-x-auto overflow-y-hidden ${
                        theme === 'light' ? 'scrollbar-super-thin-lightMode' : 'scrollbar-super-thin'
                      }`}
                      style={{ paddingBottom: '2px' }}
                    >
                      <div className="min-w-[600px] h-full">
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart
                            data={burndownChartData}
                            margin={{ top: 5, right: 30, left: -20, bottom: 0 }}
                          >
                            <CartesianGrid
                              strokeDasharray="5 5"
                              stroke={theme === 'light' ? '#BBCFE6' : '#2d3e52'}
                              horizontal
                              vertical
                            />
                            <XAxis
                              dataKey="day"
                              stroke={theme === 'light' ? '#24527A' : '#e1def5e6'}
                              tick={{ fontSize: '11px' }}
                              axisLine={false}
                              tickLine={false}
                              interval={0}
                              tickFormatter={(value, index) => (index === 0 ? '' : value)}
                        />
                            <YAxis
                              stroke={theme === 'light' ? '#24527A' : '#e1def5e6'}
                              tick={{ fontSize: '11px' }}
                              axisLine={false}
                              tickLine={false}
                            />
                            <Tooltip
                              contentStyle={{
                                backgroundColor: theme === 'light' ? '#0D1621' : '#173A5A',
                                border: theme === 'light' ? 'none' : '1px solid #224F78',
                                borderRadius: '6px',
                                padding: '6px 8px',
                                fontSize: '11px',
                                color: theme === 'light' ? '#FFFFFF' : '#fff',
                              }}
                              itemStyle={{ display: 'none' }}
                              formatter={() => ''}
                              labelFormatter={(label, payload) => {
                                const ideal = payload.find((p) => p.dataKey === 'ideal');
                                const actual = payload.find((p) => p.dataKey === 'actual');
                                const capacity = payload.find((p) => p.dataKey === 'capacity');

                                return (
                                  <div style={{ lineHeight: 1.5 }}>
                                    <div style={{ marginBottom: '4px' }}>{label}</div>
                                    {capacity && (
                                      <div
                                        style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                      >
                                        <div
                                          style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: '#4CAF50',
                                            flexShrink: 0,
                                          }}
                                        />
                                        <span style={{ color: theme === 'light' ? '#FFFFFF' : '#fff' }}>
                                          Capacity: {capacity.value}
                                        </span>
                                      </div>
                                    )}
                                    {ideal && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '6px',
                                          marginBottom: '2px',
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: '#F59F12',
                                            flexShrink: 0,
                                          }}
                                        />
                                        <span style={{ color: theme === 'light' ? '#FFFFFF' : '#fff' }}>
                                          Ideal: {ideal.value}
                                        </span>
                                      </div>
                                    )}
                                    {actual && (
                                      <div
                                        style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                      >
                                        <div
                                          style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: '#066FD1',
                                            flexShrink: 0,
                                          }}
                                        />
                                        <span style={{ color: theme === 'light' ? '#FFFFFF' : '#fff' }}>
                                          Actual: {actual.value}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                );
                              }}
                            />
                            <Line
                              type="monotone"
                              dataKey="ideal"
                              stroke="#F59F12"
                              dot={false}
                              strokeWidth={2}
                            />
                            <Line
                              type="monotone"
                              dataKey="actual"
                              stroke={theme === 'light' ? '#0077E6' : '#066FD1'}
                              dot={false}
                              strokeWidth={2}
                            />
                            <Line
                              type="monotone"
                              dataKey="capacity"
                              stroke="#4CAF50"
                              strokeDasharray="5 5"
                              dot={false}
                              strokeWidth={2}
                            />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                    {/* Sticky-Like Bottom Legend */}
                    <div
                      className={`flex justify-center items-center space-x-4 px-2 py-1 text-xs flex-shrink-0 ${
                        theme === 'light' ? 'text-[#626262]' : 'text-[#A3B1C9]'
                      }`}
                    >
                      <div className="flex items-center">
                        <span
                          className="w-3 h-3 rounded-full inline-block mr-2"
                          style={{ backgroundColor: '#4CAF50' }}
                        />
                        Capacity
                      </div>
                      <div className="flex items-center">
                        <span
                          className="w-3 h-3 rounded-full inline-block mr-2"
                          style={{ backgroundColor: '#F59F12' }}
                        />
                        Ideal
                      </div>
                      <div className="flex items-center">
                        <span
                          className="w-3 h-3 rounded-full inline-block mr-2"
                          style={{ backgroundColor: theme === 'light' ? '#0077E6' : '#066FD1' }}
                        />
                        Actual
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="flex items-center justify-center h-full text-[#24527A] dark:text-gray-500">
                    Please select a Sprint or Release
                  </div>
                )}
              </div>
              )} {/* legacy inline burndown — disabled */}

              {/* Burnup Chart - sprint only; supports both Story Points and Hours */}
              {selectedValue?.value === APP_STRINGS.VALUE_SPRINT && (
                <Suspense fallback={chartSuspenseFallback}>
                  <LazyBurnupChart
                    dailyBurnup={dailyBurnup}
                    actualStory={actualStory}
                    burndownData={newBurndownData}
                    sprintStartDate={jiraData?.Sprint?.startDate}
                    sprintEndDate={jiraData?.Sprint?.endDate}
                    showAddedWork={showAddedWork}
                    onShowAddedWorkChange={setShowAddedWork}
                    burnupModePoints={burnupModePoints}
                    onBurnupModePointsChange={setBurnupModePoints}
                    pointsSourceType={pointsSourceType}
                    isHoursBasedProject={isHoursBasedProject}
                    lockToHours={lockToHours}
                    lockToPoints={lockToPoints}
                    initialStoryPoint={initialStoryPoint}
                    initialHours={initialHours}
                    selectedDeveloper={selectedDeveloper}
                    initialEffortByDevMemo={initialEffortByDevMemo}
                    spilloverStoryPoints={spilloverStoryPoints}
                    spilloverHours={spilloverHours}
                    committedStoryPoints={committedStoryPoints}
                    committedHours={committedHours}
                    lastLoggedDate={lastLoggedDate}
                    theme={theme}
                    isGithubIssues={isGithubIssues}
                  />
                </Suspense>
              )}

              {/* Sprint Goal Success & Velocity */}
              {!selectedDeveloper && !isReleaseSelected && (
                <StandUpSprintGoalSuccessSection
                  selectedDeveloper={selectedDeveloper}
                  selectedValueDisplay={selectedValueDisplay}
                  theme={theme}
                  isSprintGoalStoryPoints={isSprintGoalStoryPoints}
                  setIsSprintGoalStoryPoints={setIsSprintGoalStoryPoints}
                  sprintGoalWorkMode={sprintGoalWorkMode}
                  setSprintGoalWorkMode={setSprintGoalWorkMode}
                  lockToHours={lockToHours}
                  lockToPoints={lockToPoints}
                  pointsSourceType={pointsSourceType}
                  sprintdata={sprintdata}
                  isUsingStoryPoints={isUsingStoryPoints}
                  heavyChartsReady={heavyChartsReady}
                  chartSuspenseFallback={chartSuspenseFallback}
                  sprintGoalRechartsPayload={sprintGoalRechartsPayload}
                  SprintGoalBarChart={SprintGoalBarChart}
                  isGithubIssues={isGithubIssues}
                />
              )}
            </div>
            )}
            {/* Pull Request Summary Card — shown only when code source integration is enabled */}
            {jiraData?.standupVisibility?.code_source === true && !isBacklogMode && (
              <StandUpPRSummarySection
                theme={theme}
                prLabel={prLabel}
                prPluralShortLabel={prPluralShortLabel}
                prShortLabel={prShortLabel}
                prSummaryTooltip={prSummaryTooltip}
                openPrData={openPrData}
                prFilterType={prFilterType}
                setPrFilterType={setPrFilterType}
                heavyChartsReady={heavyChartsReady}
                chartSuspenseFallback={chartSuspenseFallback}
                AGrid={AGrid}
                prRowData={prRowData}
                filteredPRColumns={filteredPRColumns}
                onPRGridReady={onPRGridReady}
              />
            )}

            {/* QA Insights Component */}
            {!isCreatedDateFilter && !isBacklogMode && !selectedDeveloper && (
              <div className="pt-5 ml-5 mr-2">
                <QAInsights />
              </div>
            )}

            <div className="pt-5 flex flex-wrap gap-4 items-stretch justify-between mr-2">
              <StandUpJiraTableSection
                theme={theme}
                selectedStatuses={selectedStatuses}
                onToggleStatus={toggleStatus}
                selectedCategories={selectedCategories}
                onToggleCategory={toggleCategory}
                categoryBadgeCounts={categoryBadgeCounts}
                colorMap={statusColorMap}
                badgesRef={statusBadgesRef}
                statusCarouselContainerRef={statusCarouselContainerRef}
                shouldShowArrows={shouldShowArrows}
                isStatusAtStart={isStatusAtStart}
                isStatusAtEnd={isStatusAtEnd}
                onStatusCarouselPrev={handleStatusCarouselPrev}
                onStatusCarouselNext={handleStatusCarouselNext}
                getVisibleStatusItems={getVisibleStatusItems}
                allColumns={allColumns}
                visibleColumns={displayVisibleColumns}
                onColumnToggle={handleColumnToggle}
                onColumnsClearAll={handleColumnsClearAll}
                isColumnSelectorOpen={isColumnSelectorOpen}
                setIsColumnSelectorOpen={setIsColumnSelectorOpen}
                columnSelectorRef={columnSelectorRef}
                heavyChartsReady={heavyChartsReady}
                chartSuspenseFallback={chartSuspenseFallback}
                AGrid={AGrid}
                filteredRowData={displayFilteredRowData}
                columnDefs={columnDefsWithApi.filter((col) =>
                  displayVisibleColumns.includes(col.field),
                )}
                defaultColDef={defaultColDef}
                onJiraGridApiReady={onJiraGridApiReady}
                onFilterChanged={onFilterChanged}
                clearFiltersSignal={clearFiltersSignal}
                aGridRef={aGridRef}
                hideCategoryBadges={isBacklogMode}
              />
            </div>
          </>
        )}
      </CommonLayout>
    </div>
  );
};

StandUpPage.propTypes = {
  initialData: PropTypes.shape({
    allocated: PropTypes.number.isRequired,
    remaining: PropTypes.number.isRequired,
    overloaded: PropTypes.number.isRequired,
    underutilized: PropTypes.number.isRequired,
  }),
  statusData: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      count: PropTypes.number,
      color: PropTypes.string,
    }),
  ).isRequired,
  selectedStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
  capacityRowData: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      capacity: PropTypes.number.isRequired,
      leaves: PropTypes.number,
      adjustedCapacity: PropTypes.number,
    }),
  ),
};

export default StandUpPage;